import * as React from "react";
import './ContentSVG.css'
const ContentSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-social-media"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <style>
      {
        "svg#freepik_stories-social-media:not(.animated) .animable {opacity: 0;}svg#freepik_stories-social-media.animated #freepik--background-complete--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-social-media.animated #freepik--Shadow--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-social-media.animated #freepik--Floor--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-social-media.animated #freepik--Device--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-social-media.animated #freepik--paper-plane--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-social-media.animated #freepik--Character--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-social-media.animated #freepik--speech-bubbles--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-social-media.animated #freepik--Icons--inject-69 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut,1.5s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        "
      }
    </style>
    <g
      id="freepik--background-complete--inject-69"
      className="animable animator-active"
      style={{
        transformOrigin: "246.438px 264.164px",
      }}
    >
      <path
        d="M62.21,282.61a29,29,0,1,1,39.42,11.29A29,29,0,0,1,62.21,282.61Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "87.567px 268.538px",
        }}
        id="elp1g3fz15mh8"
        className="animable"
      />
      <path
        d="M102.79,268.14c-1.9,9.68-10.56,17.48-10.56,17.48s-11.44-2.31-18-9.67c-5.47-6.15-5.34-14.44-.24-17.64,7.3-4.58,13.13,8.72,13.13,8.72S85.39,252.61,94,252.84C100,253,104.36,260.07,102.79,268.14Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "86.6293px 269.229px",
        }}
        id="elj288ai1u1e"
        className="animable"
      />
      <path
        d="M418.36,382.16a29,29,0,1,1,15.58-30.31A28.71,28.71,0,0,1,418.36,382.16Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "405.295px 356.277px",
        }}
        id="elrco6wz8x9b"
        className="animable"
      />
      <path
        d="M414.36,353.74a8.82,8.82,0,1,1-8-9.55A8.82,8.82,0,0,1,414.36,353.74Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "405.573px 352.975px",
        }}
        id="elgcf4jreu6vr"
        className="animable"
      />
      <path
        d="M418.67,378.53l-.31,3.63A29,29,0,0,1,388,379.53l.31-3.61a15.24,15.24,0,1,1,30.37,2.61Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "403.368px 373.619px",
        }}
        id="el9yvm64n6m3a"
        className="animable"
      />
      <path
        d="M112.7,373h-3.43a3.86,3.86,0,0,1-3.89-3.89,3.9,3.9,0,0,1,3.89-3.89h4.78l2.24-13H112a3.89,3.89,0,0,1,0-7.77h5.69l1.48-8.88a3.81,3.81,0,0,1,3.88-3.22,4,4,0,0,1,3.89,4.57l-1.33,7.53h11.71l1.5-8.88a3.83,3.83,0,0,1,4-3.22,4,4,0,0,1,3.81,4.57l-1.28,7.53h3.45a3.89,3.89,0,0,1,0,7.77h-4.78l-2.24,13h4.25a3.85,3.85,0,0,1,3.88,3.89,3.9,3.9,0,0,1-3.88,3.89h-5.6l-1.57,9.17a3.85,3.85,0,0,1-3.89,3.21,3.94,3.94,0,0,1-3.88-4.54l1.42-7.84H120.69l-1.57,9.17a3.89,3.89,0,0,1-3.94,3.21,3.82,3.82,0,0,1-3.82-4.54Zm21-7.78,2.24-13H124.28l-2.24,13Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "128.936px 358.863px",
        }}
        id="eltt070nubd4f"
        className="animable"
      />
      <path
        d="M380.69,143.55a25.11,25.11,0,1,0-10.08,49.19,24.54,24.54,0,0,0,6.14.46,2,2,0,0,0,1.62-.68,2,2,0,0,0,.49-1.58,1.74,1.74,0,0,0-.44-1.35,2.29,2.29,0,0,0-1.78-.7,18.9,18.9,0,0,1-5.14-.5,20.66,20.66,0,1,1,24.37-16.14,19.51,19.51,0,0,1-4.13,8.78c-.33.51-2.29,2.45-4.27,2.54l-.49-.1c-.62-.13-.74-.36-.75-.38a5.33,5.33,0,0,1-.16-1.45c.21-2.49,2-9.95,2.07-10l.19-.91c1.5-7.35-2.95-14.5-9.94-15.93s-14,3.36-15.53,10.71,3,14.67,10,16.12a12.27,12.27,0,0,0,9.09-1.69l-.23,1.12a6.55,6.55,0,0,0,.45,3.84,5.26,5.26,0,0,0,3.89,2.94,5.52,5.52,0,0,0,1.54.16,11.72,11.72,0,0,0,7.43-3.88c.08-.08.13-.14.15-.14l.11-.11a25.26,25.26,0,0,0-14.63-40.29ZM373.83,177c-4.63-.95-7.44-5.61-6.41-10.62s5.54-8.24,10.08-7.31,7.48,5.82,6.48,10.7S378.41,178,373.83,177Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "375.387px 168.089px",
        }}
        id="el14vzov8jlxrh"
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadow--inject-69"
      className="animable"
      style={{
        transformOrigin: "250px 448.75px",
      }}
    >
      <ellipse
        cx={250}
        cy={448.75}
        rx={158.42}
        ry={21.21}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "250px 448.75px",
        }}
        id="el6ftyo1yrjxr"
        className="animable"
      />
    </g>
    <g
      id="freepik--Floor--inject-69"
      className="animable"
      style={{
        transformOrigin: "249.995px 418.815px",
      }}
    >
      <polygon
        points="46.98 418.81 97.74 418.57 148.49 418.48 250 418.32 351.51 418.48 402.26 418.57 453.01 418.81 402.26 419.06 351.51 419.15 250 419.31 148.49 419.15 97.74 419.06 46.98 418.81"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "249.995px 418.815px",
        }}
        id="elwvynla7qmn"
        className="animable"
      />
    </g>
    <g
      id="freepik--Device--inject-69"
      className="animable"
      style={{
        transformOrigin: "250.02px 253.34px",
      }}
    >
      <path
        d="M334.51,61.92h-169a17.26,17.26,0,0,0-17.11,17.42v348a17.27,17.27,0,0,0,17.11,17.42h169a17.28,17.28,0,0,0,17.13-17.42v-348A17.27,17.27,0,0,0,334.51,61.92Zm6.43,354.67c0,9.16-6.86,16.57-15.31,16.57H174.39c-8.49,0-15.34-7.41-15.34-16.57V92.53c0-18.66,6.85-19.57,15.34-19.57h30.29c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.09,5.83h70c4,0,7.09,0,7.09-5.83V77.44c0-2.48,1.42-4.48,3.22-4.48h30.3c8.45,0,15.31,2.48,15.31,19.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "250.02px 253.34px",
        }}
        id="els2jur5yev1f"
        className="animable"
      />
      <path
        d="M259.55,77.08H240.44a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h19.11a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.55,77.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "249.995px 75.9px",
        }}
        id="elzm37fidnrfk"
        className="animable"
      />
      <path
        d="M340.94,92.53V416.59c0,9.16-6.86,16.57-15.31,16.57H174.39c-8.49,0-15.34-7.41-15.34-16.57V92.53c0-18.66,6.85-19.57,15.34-19.57h30.29c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.09,5.83h70c4,0,7.09,0,7.09-5.83V77.44c0-2.48,1.42-4.48,3.22-4.48h30.3C334.08,73,340.94,75.44,340.94,92.53Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "249.995px 253.06px",
        }}
        id="el8fh6sw4f9t"
        className="animable"
      />
      <path
        d="M185.34,94.77H170.86V84.66h2.79l.63-2.44h7.64l.63,2.44h2.79Zm-13.48-1h12.48V85.66h-2.56l-.63-2.44h-6.1l-.63,2.44h-2.56Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "178.1px 88.495px",
        }}
        id="elo3b1934vp6"
        className="animable"
      />
      <path
        d="M178.1,92.61a3.52,3.52,0,1,1,3.51-3.51A3.51,3.51,0,0,1,178.1,92.61Zm0-6a2.52,2.52,0,1,0,2.51,2.52A2.51,2.51,0,0,0,178.1,86.58Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "178.09px 89.09px",
        }}
        id="el2ldxt4d2l5f"
        className="animable"
      />
      <path
        d="M322.56,94.69c-.15-.11-3.75-2.55-5.29-5.39-1.08-2-1.23-4.21-.37-5.65a2.83,2.83,0,0,1,2.5-1.43,3.9,3.9,0,0,1,3.44,2.43,3.9,3.9,0,0,1,3.44-2.43,2.83,2.83,0,0,1,2.5,1.43,6,6,0,0,1-.37,5.65h0c-1.55,2.84-5.14,5.28-5.29,5.39ZM319.4,83.22a1.84,1.84,0,0,0-1.64.94,5,5,0,0,0,.39,4.66,17.46,17.46,0,0,0,4.69,4.84,17.61,17.61,0,0,0,4.69-4.84,5,5,0,0,0,.39-4.66,1.84,1.84,0,0,0-1.64-.94c-2.28,0-2.93,2.89-2.95,3h-1C322.32,86.11,321.68,83.22,319.4,83.22ZM328,89.06h0Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "322.83px 88.4549px",
        }}
        id="elwxmyy1o9ux"
        className="animable"
      />
      <path
        d="M186.39,120.19a9.93,9.93,0,0,1-2.93,1.23,10.17,10.17,0,1,1,2.93-1.23Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "181.037px 111.543px",
        }}
        id="elldjrqw8wnj"
        className="animable"
      />
      <path
        d="M184.14,110.4a3.09,3.09,0,1,1-3.09-3.09A3.09,3.09,0,0,1,184.14,110.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "181.05px 110.4px",
        }}
        id="elctj3v4ozj5f"
        className="animable"
      />
      <path
        d="M186.39,118.92v1.27a9.93,9.93,0,0,1-2.93,1.23,10.11,10.11,0,0,1-7.74-1.23v-1.27a5.34,5.34,0,1,1,10.67,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "181.055px 117.53px",
        }}
        id="el787o5ckdjxm"
        className="animable"
      />
      <path
        d="M194.31,119.63a4.66,4.66,0,1,1-4.66-4.66A4.66,4.66,0,0,1,194.31,119.63Z"
        style={{
          fill: "#213E60",
          transformOrigin: "189.65px 119.63px",
        }}
        id="elixjh7q3hyge"
        className="animable"
      />
      <rect
        x={189.01}
        y={116.81}
        width={1.29}
        height={5.63}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "189.655px 119.625px",
        }}
        id="ely246wlfodtd"
        className="animable"
      />
      <g id="el4wqassbp604">
        <rect
          x={189.01}
          y={116.81}
          width={1.29}
          height={5.63}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "189.655px 119.625px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          id="elq4pgibxg2uc"
        />
      </g>
      <path
        d="M172,127.69l-.94-1.28a.11.11,0,0,1,0-.14.1.1,0,0,1,.14,0l.87,1.2.88-1.2a.1.1,0,0,1,.14,0,.11.11,0,0,1,0,.14l-.94,1.27v1.26a.1.1,0,0,1-.09.1.11.11,0,0,1-.1-.1Z"
        id="ellrx0j51soik"
        className="animable"
        style={{
          transformOrigin: "172.075px 127.641px",
        }}
      />
      <path
        d="M174,127.08a1,1,0,0,1,0,2,1,1,0,0,1,0-2Zm0,1.76a.77.77,0,0,0,.74-.78.78.78,0,0,0-.74-.8.77.77,0,0,0-.73.8A.76.76,0,0,0,174,128.84Z"
        id="elfdkb4kscr79"
        className="animable"
        style={{
          transformOrigin: "174px 128.08px",
        }}
      />
      <path
        d="M175.53,127.17a.1.1,0,0,1,.1-.1.09.09,0,0,1,.09.1v1.07a.61.61,0,0,0,1.21,0v-1.07a.1.1,0,1,1,.2,0v1.07a.8.8,0,0,1-.81.8.79.79,0,0,1-.79-.8Z"
        id="elojg9fp2pur"
        className="animable"
        style={{
          transformOrigin: "176.33px 128.055px",
        }}
      />
      <path
        d="M178,127.18a.1.1,0,1,1,.2,0v.43s0,0,0,0a1,1,0,0,1,.79-.48.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09.71.71,0,0,0-.57.32,2,2,0,0,0-.24.46v.89a.1.1,0,0,1-.2,0Z"
        id="eldduw9ny7hxe"
        className="animable"
        style={{
          transformOrigin: "178.53px 128.085px",
        }}
      />
      <path
        d="M180.9,128.51a.08.08,0,0,1,.12,0,1.54,1.54,0,0,0,.92.36,1,1,0,0,0,.61-.18.52.52,0,0,0,.24-.42.43.43,0,0,0-.22-.38,1.89,1.89,0,0,0-.65-.23h0a1.71,1.71,0,0,1-.66-.24.58.58,0,0,1-.29-.49.65.65,0,0,1,.3-.52,1.11,1.11,0,0,1,.67-.2,1.56,1.56,0,0,1,.86.32.09.09,0,1,1-.09.15,1.35,1.35,0,0,0-.77-.3,1,1,0,0,0-.57.17.48.48,0,0,0-.22.38.39.39,0,0,0,.21.34,1.54,1.54,0,0,0,.6.22h0a2,2,0,0,1,.72.25.64.64,0,0,1,.3.53.7.7,0,0,1-.31.56,1.21,1.21,0,0,1-.72.22,1.73,1.73,0,0,1-1-.4A.09.09,0,0,1,180.9,128.51Z"
        id="el6t9g23rm3f"
        className="animable"
        style={{
          transformOrigin: "181.931px 127.63px",
        }}
      />
      <path
        d="M184.31,127.17a.11.11,0,0,1-.09.1H184v1.43a.16.16,0,0,0,.15.14.1.1,0,0,1,0,.2.34.34,0,0,1-.35-.34v-1.43h-.24c-.1,0-.1,0-.1-.1s0-.09.1-.09h.24v-.73a.1.1,0,0,1,.2,0v.73h.26A.1.1,0,0,1,184.31,127.17Z"
        id="el17ydxjkdunl"
        className="animable"
        style={{
          transformOrigin: "183.885px 127.645px",
        }}
      />
      <path
        d="M186,127.08a1,1,0,1,1-.92,1A1,1,0,0,1,186,127.08Zm0,1.76a.77.77,0,0,0,.74-.78.78.78,0,0,0-.74-.8.77.77,0,0,0-.73.8A.76.76,0,0,0,186,128.84Z"
        id="elv413ufgb94e"
        className="animable"
        style={{
          transformOrigin: "186.08px 128.077px",
        }}
      />
      <path
        d="M187.59,127.18a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v.43l0,0a1,1,0,0,1,.78-.48.1.1,0,0,1,.1.1.1.1,0,0,1-.1.09.74.74,0,0,0-.57.32,1.91,1.91,0,0,0-.23.46,0,0,0,0,0,0,0v.86a.09.09,0,0,1-.09.1.09.09,0,0,1-.1-.1Z"
        id="el3vlc8n73v6e"
        className="animable"
        style={{
          transformOrigin: "188.115px 128.07px",
        }}
      />
      <path
        d="M189.18,127.17a.09.09,0,0,1,.09-.09.09.09,0,0,1,.1.09v1.06a.6.6,0,0,0,.6.61.61.61,0,0,0,.61-.61v-1.06a.07.07,0,0,1,0,0h0l0,0h.05l0,0a0,0,0,0,1,0,0,.06.06,0,0,1,0,0v1.71a.92.92,0,0,1-.93.92,1.06,1.06,0,0,1-.4-.09.09.09,0,0,1,0-.13.1.1,0,0,1,.12-.05.72.72,0,0,0,.32.08.74.74,0,0,0,.74-.73v-.13a.79.79,0,0,1-1.4-.52Z"
        id="ely9d8381ebg"
        className="animable"
        style={{
          transformOrigin: "189.855px 128.44px",
        }}
      />
      <path
        d="M219,120.19a10,10,0,0,1-2.92,1.23,10.17,10.17,0,1,1,2.92-1.23Z"
        style={{
          fill: "#213E60",
          transformOrigin: "213.64px 111.547px",
        }}
        id="elilgn98k612c"
        className="animable"
      />
      <path
        d="M213.66,123.78A12.22,12.22,0,1,1,220,101.12a12.21,12.21,0,0,1,.08,20.83,11.84,11.84,0,0,1-3.52,1.47A12.3,12.3,0,0,1,213.66,123.78Zm.05-23.44a11.21,11.21,0,1,0,2.64,22.11,11,11,0,0,0,3.23-1.35h0a11.22,11.22,0,0,0-5.87-20.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "213.653px 111.56px",
        }}
        id="el1gus5oxeoa8"
        className="animable"
      />
      <path
        d="M216.78,110.4a3.09,3.09,0,1,1-3.09-3.09A3.09,3.09,0,0,1,216.78,110.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "213.69px 110.4px",
        }}
        id="eluqfqrz3ko6j"
        className="animable"
      />
      <path
        d="M219,118.92v1.27a10,10,0,0,1-2.92,1.23,10.13,10.13,0,0,1-7.75-1.23v-1.27a5.34,5.34,0,1,1,10.67,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "213.665px 117.53px",
        }}
        id="elrtjoelpwdl"
        className="animable"
      />
      <path
        d="M204.76,127.18a.09.09,0,0,1,.1-.1.1.1,0,0,1,.09.1v.43a.13.13,0,0,1,0,0,.93.93,0,0,1,.78-.48.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09.73.73,0,0,0-.57.32,1.59,1.59,0,0,0-.23.46,0,0,0,0,0,0,0v.86a.1.1,0,0,1-.09.1.09.09,0,0,1-.1-.1Z"
        id="elam0u2vlnktg"
        className="animable"
        style={{
          transformOrigin: "205.28px 128.07px",
        }}
      />
      <path
        d="M208.05,127.17v1.77a.1.1,0,0,1-.09.1.11.11,0,0,1-.1-.1v-.29a.91.91,0,0,1-.73.39,1,1,0,0,1,0-2,.9.9,0,0,1,.73.38v-.29a.1.1,0,0,1,.1-.09A.09.09,0,0,1,208.05,127.17Zm-.19.89a.77.77,0,0,0-.73-.8.78.78,0,0,0-.74.8.76.76,0,0,0,.74.78A.75.75,0,0,0,207.86,128.06Z"
        id="elh47mq6ynnto"
        className="animable"
        style={{
          transformOrigin: "207.095px 128.04px",
        }}
      />
      <path
        d="M211.69,127.88a.61.61,0,0,0-.61-.61.6.6,0,0,0-.6.61V129h0s0,0,0,.05l-.05,0h-.09v0h0v-1.06a.61.61,0,1,0-1.21,0v1.06a.08.08,0,0,1,0,.08H209a.11.11,0,0,1-.08-.08v-1.79a.09.09,0,1,1,.18,0v.19a1.68,1.68,0,0,0,2-.28.8.8,0,0,1,.8.8v1.06a.1.1,0,0,1-.1.1.1.1,0,0,1-.09-.1Z"
        id="elpqhms45b0bf"
        className="animable"
        style={{
          transformOrigin: "210.41px 128.15px",
        }}
      />
      <path
        d="M213.53,127.08a1,1,0,0,1,0,2,1,1,0,0,1,0-2Zm0,1.76a.76.76,0,0,0,.73-.78.77.77,0,0,0-.73-.8.78.78,0,0,0-.74.8A.77.77,0,0,0,213.53,128.84Z"
        id="elfrmigo3vng6"
        className="animable"
        style={{
          transformOrigin: "213.53px 128.08px",
        }}
      />
      <path
        d="M216.59,127.88a.6.6,0,0,0-.6-.61.61.61,0,0,0-.61.61V129l0,0a.1.1,0,0,1-.07,0h0a.09.09,0,0,1-.06-.06h0v-1.78a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v.18a.79.79,0,0,1,1.4.52v1.06a.09.09,0,0,1-.09.1.09.09,0,0,1-.1-.1Z"
        id="elmztkbtm18f"
        className="animable"
        style={{
          transformOrigin: "216.045px 128.036px",
        }}
      />
      <path
        d="M217.8,128.64a.19.19,0,0,1,.2.2.2.2,0,1,1-.4,0A.19.19,0,0,1,217.8,128.64Z"
        id="elsmkj8dp8x09"
        className="animable"
        style={{
          transformOrigin: "217.8px 128.84px",
        }}
      />
      <path
        d="M220.1,126.41l-.72.75a.91.91,0,0,1,.75.92,1,1,0,0,1-.95,1,1,1,0,0,1-.67-.28.1.1,0,1,1,.14-.14.77.77,0,0,0,.53.21.76.76,0,0,0,.53-.21.75.75,0,0,0,.22-.54.75.75,0,0,0-.74-.74.1.1,0,0,1-.08,0h0a.11.11,0,0,1,0-.15l.7-.71h-1.07a.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1H220a.09.09,0,0,1,.1.1.06.06,0,0,1,0,0S220.11,126.4,220.1,126.41Z"
        id="el3i8umijca2u"
        className="animable"
        style={{
          transformOrigin: "219.3px 127.7px",
        }}
      />
      <path
        d="M220.85,128.86l1.3-1.18a.69.69,0,0,0,.24-.53.72.72,0,0,0-.18-.48.72.72,0,0,0-1,0l-.14.12a.09.09,0,0,1-.13,0,.1.1,0,0,1,0-.14l.14-.13a1,1,0,0,1,.62-.23.87.87,0,0,1,.67.3.89.89,0,0,1,.24.61.93.93,0,0,1-.3.68l-1.12,1h1.32a.1.1,0,0,1,.1.1.11.11,0,0,1-.1.1h-1.57a.11.11,0,0,1-.08,0A.12.12,0,0,1,220.85,128.86Z"
        id="ellaelqa8qllm"
        className="animable"
        style={{
          transformOrigin: "221.696px 127.689px",
        }}
      />
      <path
        d="M251.78,120.19a10,10,0,0,1-2.92,1.23,10.17,10.17,0,1,1,2.92-1.23Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "246.42px 111.547px",
        }}
        id="eligc437wxiq"
        className="animable"
      />
      <path
        d="M246.42,123.78a12.22,12.22,0,1,1,6.45-1.83,11.9,11.9,0,0,1-3.53,1.47A12.16,12.16,0,0,1,246.42,123.78Zm.05-23.44a11.21,11.21,0,1,0,5.87,20.76h0a11.22,11.22,0,0,0-5.87-20.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "246.438px 111.56px",
        }}
        id="elerca69dgd4u"
        className="animable"
      />
      <path
        d="M249.53,110.4a3.09,3.09,0,1,1-3.08-3.09A3.08,3.08,0,0,1,249.53,110.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "246.44px 110.4px",
        }}
        id="eluofv8bwxkb"
        className="animable"
      />
      <path
        d="M251.78,118.92v1.27a10,10,0,0,1-2.92,1.23,10.13,10.13,0,0,1-7.75-1.23v-1.27a5.34,5.34,0,1,1,10.67,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "246.445px 117.53px",
        }}
        id="elivwgvfebmkn"
        className="animable"
      />
      <path
        d="M239.1,127.18a.1.1,0,0,1,.2,0v.43s0,0,0,0a1,1,0,0,1,.79-.48.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09.73.73,0,0,0-.57.32,2,2,0,0,0-.24.46v.89a.1.1,0,0,1-.2,0Z"
        id="elgpm084g674s"
        className="animable"
        style={{
          transformOrigin: "239.63px 128.085px",
        }}
      />
      <path
        d="M240.86,126.53a.1.1,0,0,1,.1-.09.09.09,0,0,1,.1.09v.09a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11Zm0,.64a.1.1,0,0,1,.1-.09.09.09,0,0,1,.1.09v1.77a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1Z"
        id="el82rxe5ahp6f"
        className="animable"
        style={{
          transformOrigin: "240.96px 127.74px",
        }}
      />
      <path
        d="M242,127.18a.1.1,0,1,1,.2,0v.43s0,0,0,0a1,1,0,0,1,.79-.48.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09.73.73,0,0,0-.57.32,2,2,0,0,0-.24.46v.89a.1.1,0,0,1-.2,0Z"
        id="elmmcejcoxwdl"
        className="animable"
        style={{
          transformOrigin: "242.53px 128.085px",
        }}
      />
      <path
        d="M243.74,126.53a.1.1,0,0,1,.1-.09.09.09,0,0,1,.1.09v.09a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11Zm0,.64a.1.1,0,0,1,.1-.09.09.09,0,0,1,.1.09v1.77a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1Z"
        id="el4zi3xi17szo"
        className="animable"
        style={{
          transformOrigin: "243.84px 127.74px",
        }}
      />
      <path
        d="M244.4,129.59a.09.09,0,0,1,.08-.09h2.42a.09.09,0,0,1,.09.09.09.09,0,0,1-.09.08h-2.42A.09.09,0,0,1,244.4,129.59Z"
        id="eltrp0l7xxqi9"
        className="animable"
        style={{
          transformOrigin: "245.695px 129.585px",
        }}
      />
      <path
        d="M247.31,126.33a.09.09,0,0,1,.09-.09h1.45a.09.09,0,0,1,.09.09.09.09,0,0,1-.09.1H247.5v1.11h1.18a.1.1,0,0,1,.1.1.11.11,0,0,1-.1.1H247.5v1.2a.1.1,0,0,1-.1.1.1.1,0,0,1-.09-.1Z"
        id="elm4nn6j5ygn"
        className="animable"
        style={{
          transformOrigin: "248.125px 127.64px",
        }}
      />
      <path
        d="M249.48,128.06a1,1,0,0,1,1-1,1,1,0,0,1,.94.91h0a.09.09,0,0,1-.1.09h-1.6a.76.76,0,0,0,.76.75.74.74,0,0,0,.63-.35.08.08,0,0,1,.12,0,.1.1,0,0,1,0,.13.94.94,0,0,1-.79.45A1,1,0,0,1,249.48,128.06Zm.21-.16h1.48a.75.75,0,0,0-1.48,0Z"
        id="elyzxvfm07kt"
        className="animable"
        style={{
          transformOrigin: "250.45px 128.05px",
        }}
      />
      <path
        d="M252,127.17a.09.09,0,0,1,.09-.09.09.09,0,0,1,.1.09v1.06a.6.6,0,0,0,.6.61.61.61,0,0,0,.61-.61v-1.06a.07.07,0,0,1,0,0h0a0,0,0,0,1,0,0l0,0h.05l0,0s0,0,0,0a.06.06,0,0,1,0,0v1.71a.93.93,0,0,1-.93.92,1,1,0,0,1-.4-.09.09.09,0,0,1,0-.13.1.1,0,0,1,.12-.05.69.69,0,0,0,.32.08.74.74,0,0,0,.74-.73v-.13a.82.82,0,0,1-.61.28.79.79,0,0,1-.79-.8Z"
        id="elo6m0k45jm0p"
        className="animable"
        style={{
          transformOrigin: "252.675px 128.44px",
        }}
      />
      <path
        d="M284.54,120.19a9.93,9.93,0,0,1-2.93,1.23,10.17,10.17,0,1,1,2.93-1.23Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "279.187px 111.543px",
        }}
        id="elk2fgd9pafz"
        className="animable"
      />
      <path
        d="M279.18,123.78a12,12,0,0,1-6.4-1.84,12.21,12.21,0,1,1,12.85,0,11.9,11.9,0,0,1-3.53,1.47A12.16,12.16,0,0,1,279.18,123.78Zm.05-23.44a11.21,11.21,0,1,0,5.87,20.76h0a11.22,11.22,0,0,0-5.87-20.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "279.205px 111.564px",
        }}
        id="elwecznl7j8ya"
        className="animable"
      />
      <path
        d="M282.29,110.4a3.09,3.09,0,1,1-3.09-3.09A3.09,3.09,0,0,1,282.29,110.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "279.2px 110.4px",
        }}
        id="elxhcq7dgulan"
        className="animable"
      />
      <path
        d="M284.54,118.92v1.27a9.93,9.93,0,0,1-2.93,1.23,10.11,10.11,0,0,1-7.74-1.23v-1.27a5.34,5.34,0,1,1,10.67,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "279.205px 117.53px",
        }}
        id="elk9lesdrsoca"
        className="animable"
      />
      <path
        d="M268.46,128.09v-.92a.1.1,0,0,1,.2,0v.29a.92.92,0,0,1,.74-.38,1,1,0,0,1,0,1.94.92.92,0,0,1-.74-.38v1.12a.1.1,0,0,1-.2,0Zm.2,0a.75.75,0,1,0,.74-.78.77.77,0,0,0-.74.78Z"
        id="elw4efgq2alf"
        className="animable"
        style={{
          transformOrigin: "269.31px 128.465px",
        }}
      />
      <path
        d="M271.94,127.08a1,1,0,0,1,0,2,1,1,0,0,1,0-2Zm0,1.76a.76.76,0,0,0,.73-.78.77.77,0,0,0-.73-.8.78.78,0,0,0-.74.8A.77.77,0,0,0,271.94,128.84Z"
        id="el0f0m1k833fha"
        className="animable"
        style={{
          transformOrigin: "271.94px 128.08px",
        }}
      />
      <path
        d="M273.47,128.63a.09.09,0,0,1,.13,0,1.05,1.05,0,0,0,.6.22.53.53,0,0,0,.37-.12.28.28,0,0,0,.15-.24c0-.09,0-.15-.14-.24a1,1,0,0,0-.41-.14h0a1.32,1.32,0,0,1-.45-.16.41.41,0,0,1-.21-.35.49.49,0,0,1,.21-.38.85.85,0,0,1,.48-.13,1,1,0,0,1,.59.21.11.11,0,0,1,0,.13.1.1,0,0,1-.14,0,.86.86,0,0,0-.48-.19.58.58,0,0,0-.37.11.28.28,0,0,0-.12.22.23.23,0,0,0,.11.2.89.89,0,0,0,.4.13h0a1.44,1.44,0,0,1,.47.16.47.47,0,0,1,0,.8.82.82,0,0,1-.49.16,1.29,1.29,0,0,1-.72-.28A.09.09,0,0,1,273.47,128.63Z"
        id="elbbuqihqriti"
        className="animable"
        style={{
          transformOrigin: "274.161px 128.055px",
        }}
      />
      <path
        d="M277,127.85a.62.62,0,0,0-1.24,0v1.09h0s0,0,0,0h0s0,0-.06.05h0a.12.12,0,0,1-.08,0l0,0v-2.64a.09.09,0,0,1,.1-.09.1.1,0,0,1,.1.09v1a.81.81,0,0,1,.62-.28.77.77,0,0,1,.81.77v1.09a.1.1,0,0,1-.09.1.1.1,0,0,1-.1-.1Z"
        id="elnog9ncemwl"
        className="animable"
        style={{
          transformOrigin: "276.435px 127.645px",
        }}
      />
      <path
        d="M278.71,127.17a.11.11,0,0,1-.1.1h-.25v1.43a.15.15,0,0,0,.14.14.1.1,0,0,1,0,.2.34.34,0,0,1-.34-.34v-1.43h-.25c-.09,0-.09,0-.09-.1s0-.09.09-.09h.25v-.73a.11.11,0,0,1,.09-.1.11.11,0,0,1,.11.1v.73h.25A.1.1,0,0,1,278.71,127.17Z"
        id="elmfweesvemr"
        className="animable"
        style={{
          transformOrigin: "278.265px 127.645px",
        }}
      />
      <path
        d="M279.34,127.18a.1.1,0,0,1,.1-.1.09.09,0,0,1,.09.1v.43l0,0a1,1,0,0,1,.79-.48.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09.71.71,0,0,0-.57.32,2,2,0,0,0-.24.46,0,0,0,0,0,0,0v.86a.09.09,0,0,1-.09.1.1.1,0,0,1-.1-.1Z"
        id="elthkp43wrmz"
        className="animable"
        style={{
          transformOrigin: "279.865px 128.07px",
        }}
      />
      <path
        d="M280.76,128.06a.95.95,0,0,1,1.89-.07h0a.08.08,0,0,1-.09.09H281a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.35.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.13.94.94,0,0,1-.79.45A1,1,0,0,1,280.76,128.06Zm.2-.16h1.48a.75.75,0,0,0-.73-.63A.76.76,0,0,0,281,127.9Z"
        id="ell15r4t6t4zf"
        className="animable"
        style={{
          transformOrigin: "281.705px 128.113px",
        }}
      />
      <path
        d="M284.73,127.88a.6.6,0,0,0-.6-.61.62.62,0,0,0-.61.61V129l0,0a.08.08,0,0,1-.07,0h0a.11.11,0,0,1-.07-.06h0v-1.78a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v.18a.82.82,0,0,1,.61-.28.8.8,0,0,1,.8.8v1.06a.1.1,0,0,1-.2,0Z"
        id="elosjsnmsxhgj"
        className="animable"
        style={{
          transformOrigin: "284.18px 128.04px",
        }}
      />
      <path
        d="M287.27,128.66a.93.93,0,0,1-.75.38,1,1,0,0,1,0-2,.93.93,0,0,1,.75.38v-1.13a.1.1,0,0,1,.1-.09.09.09,0,0,1,.1.09v2.61a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1Zm0-.57V128a.75.75,0,1,0-.75.81A.76.76,0,0,0,287.27,128.09Z"
        id="elvicuocluuig"
        className="animable"
        style={{
          transformOrigin: "286.495px 127.62px",
        }}
      />
      <path
        d="M288.18,127.17a.1.1,0,0,1,.09-.09.09.09,0,0,1,.1.09v1.06a.61.61,0,1,0,1.21,0v-1.06a.08.08,0,0,1,0,0h0a.05.05,0,0,1,0,0h0l.05,0,0,0a.06.06,0,0,1,0,0v1.71a.92.92,0,0,1-.93.92,1.06,1.06,0,0,1-.4-.09.09.09,0,0,1,0-.13.1.1,0,0,1,.12-.05.72.72,0,0,0,.32.08.74.74,0,0,0,.74-.73v-.13a.79.79,0,0,1-1.4-.52Z"
        id="el9r1k59s3ue"
        className="animable"
        style={{
          transformOrigin: "288.855px 128.44px",
        }}
      />
      <path
        d="M317.3,120.19a9.93,9.93,0,0,1-2.93,1.23,10.15,10.15,0,1,1,2.93-1.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "311.955px 111.562px",
        }}
        id="elo6u54uqt6t"
        className="animable"
      />
      <path
        d="M311.93,123.78a12.26,12.26,0,0,1-11.83-9.32A12.21,12.21,0,1,1,318.38,122a11.73,11.73,0,0,1-3.52,1.47A12.18,12.18,0,0,1,311.93,123.78Zm.06-23.44a11.21,11.21,0,0,0-5.92,20.75,11.23,11.23,0,0,0,11.79,0h0A11.22,11.22,0,0,0,312,100.34Z"
        style={{
          fill: "#213E60",
          transformOrigin: "311.972px 111.589px",
        }}
        id="elxz6is0ap24i"
        className="animable"
      />
      <path
        d="M315.05,110.4a3.09,3.09,0,1,1-3.09-3.09A3.09,3.09,0,0,1,315.05,110.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "311.96px 110.4px",
        }}
        id="elrekmmjs8trl"
        className="animable"
      />
      <path
        d="M317.3,118.92v1.27a9.93,9.93,0,0,1-2.93,1.23,10.11,10.11,0,0,1-7.74-1.23v-1.27a5.34,5.34,0,1,1,10.67,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "311.965px 117.53px",
        }}
        id="el8obncdjv14w"
        className="animable"
      />
      <path
        d="M304.26,128.09v-.92a.09.09,0,0,1,.09-.09.09.09,0,0,1,.1.09v.29a.93.93,0,0,1,.75-.38,1,1,0,0,1,0,1.94.93.93,0,0,1-.75-.38v1.12a.09.09,0,0,1-.1.09.09.09,0,0,1-.09-.09Zm.19,0a.75.75,0,1,0,.75-.78.77.77,0,0,0-.75.78Z"
        id="elbyobv3v6vvs"
        className="animable"
        style={{
          transformOrigin: "305.108px 128.465px",
        }}
      />
      <path
        d="M306.72,128.06a.95.95,0,0,1,1.89-.07h0a.08.08,0,0,1-.09.09h-1.61a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.35.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.13.94.94,0,0,1-.79.45A1,1,0,0,1,306.72,128.06Zm.2-.16h1.48a.75.75,0,0,0-.73-.63A.76.76,0,0,0,306.92,127.9Z"
        id="el161mj8i27wp"
        className="animable"
        style={{
          transformOrigin: "307.665px 128.113px",
        }}
      />
      <path
        d="M309.82,127.17a.11.11,0,0,1-.1.1h-.25v1.43a.16.16,0,0,0,.14.14.1.1,0,0,1,0,.2.34.34,0,0,1-.34-.34v-1.43H309c-.1,0-.1,0-.1-.1s0-.09.1-.09h.24v-.73a.11.11,0,0,1,.09-.1.11.11,0,0,1,.11.1v.73h.25A.1.1,0,0,1,309.82,127.17Z"
        id="elt4vah5a7bur"
        className="animable"
        style={{
          transformOrigin: "309.36px 127.645px",
        }}
      />
      <path
        d="M310.76,126.33a.1.1,0,0,1,.2,0v2.61a.1.1,0,1,1-.2,0Z"
        id="el0tv47eeagkv"
        className="animable"
        style={{
          transformOrigin: "310.86px 127.635px",
        }}
      />
      <path
        d="M312.56,127.08a1,1,0,1,1-.92,1A1,1,0,0,1,312.56,127.08Zm0,1.76a.77.77,0,0,0,.74-.78.78.78,0,0,0-.74-.8.77.77,0,0,0-.73.8A.76.76,0,0,0,312.56,128.84Z"
        id="elj7agqbdg29"
        className="animable"
        style={{
          transformOrigin: "312.64px 128.077px",
        }}
      />
      <path
        d="M314.74,129a.08.08,0,0,1,0,0l-.73-1.76a.09.09,0,0,1,0-.12.09.09,0,0,1,.12.05l.65,1.55.65-1.55a.1.1,0,0,1,.13-.05.09.09,0,0,1,.05.12l-.74,1.74s0,0,0,0l-.06,0h-.06Z"
        id="el8gf1wy1gykq"
        className="animable"
        style={{
          transformOrigin: "314.802px 128.056px",
        }}
      />
      <path
        d="M316.18,128.06a.95.95,0,0,1,1.89-.07h0a.08.08,0,0,1-.09.09h-1.61a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.35.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.13.94.94,0,0,1-.79.45A1,1,0,0,1,316.18,128.06Zm.2-.16h1.48a.75.75,0,0,0-.73-.63A.76.76,0,0,0,316.38,127.9Z"
        id="elsvkdnphjx9h"
        className="animable"
        style={{
          transformOrigin: "317.125px 128.113px",
        }}
      />
      <path
        d="M318.67,127.18a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v.43l0,0a1,1,0,0,1,.78-.48.1.1,0,0,1,.1.1.1.1,0,0,1-.1.09.71.71,0,0,0-.56.32,1.69,1.69,0,0,0-.24.46,0,0,0,0,0,0,0v.86a.09.09,0,0,1-.09.1.09.09,0,0,1-.1-.1Z"
        id="elq4bqraugodf"
        className="animable"
        style={{
          transformOrigin: "319.195px 128.07px",
        }}
      />
      <path
        d="M177.57,156.14a5,5,0,0,1-1.48.63,5.19,5.19,0,1,1,1.48-.63Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "174.822px 151.737px",
        }}
        id="elt3hooy9c4l"
        className="animable"
      />
      <path
        d="M176.43,151.17a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,176.43,151.17Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.86px 151.17px",
        }}
        id="elewh7eq2s1ri"
        className="animable"
      />
      <path
        d="M177.57,155.5v.64a5,5,0,0,1-1.48.63,5.12,5.12,0,0,1-3.94-.63v-.64a2.71,2.71,0,1,1,5.42,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.86px 154.854px",
        }}
        id="el70yrvvi39mo"
        className="animable"
      />
      <path
        d="M185.68,150.78a.23.23,0,0,1-.23.22h-.1v1.12a.22.22,0,0,1,.22.22.21.21,0,0,1-.22.22.44.44,0,0,1-.44-.44V151h-.12a.22.22,0,0,1,0-.44h.12V150a.21.21,0,0,1,.22-.21.21.21,0,0,1,.22.21v.58h.1A.23.23,0,0,1,185.68,150.78Z"
        id="el7hmrm4q3n37"
        className="animable"
        style={{
          transformOrigin: "185.125px 151.175px",
        }}
      />
      <path
        d="M186.5,152.27a1,1,0,0,1-.27-.7,1,1,0,0,1,.27-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.9.9,0,0,1-.67.31A.93.93,0,0,1,186.5,152.27Zm.16-.7a.6.6,0,0,0,.15.42.52.52,0,0,0,.38.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.56.56,0,0,0-.38.15A.6.6,0,0,0,186.66,151.57Z"
        id="el7pkbd2hg9oj"
        className="animable"
        style={{
          transformOrigin: "187.185px 151.57px",
        }}
      />
      <path
        d="M190.49,151.39h0v.95a.21.21,0,0,1-.21.21.22.22,0,0,1-.22-.21v-.95h0a.41.41,0,0,0-.81,0v.95s0,0,0,0h0a0,0,0,0,1,0,0v0a.24.24,0,0,1-.2.12h0a.21.21,0,0,1-.17-.21v-.95h0v-.62a.21.21,0,0,1,.4-.1.93.93,0,0,1,.43-.12.84.84,0,0,1,.63.28.82.82,0,0,1,.62-.28.85.85,0,0,1,.84.84v.95a.21.21,0,0,1-.22.21.21.21,0,0,1-.21-.21v-.95a.41.41,0,0,0-.41-.41A.42.42,0,0,0,190.49,151.39Z"
        id="elbc1qiqo4iyh"
        className="animable"
        style={{
          transformOrigin: "190.34px 151.504px",
        }}
      />
      <path
        d="M192.87,152a.3.3,0,1,1,0,.59.3.3,0,0,1,0-.59Z"
        id="ellsaftdxkttl"
        className="animable"
        style={{
          transformOrigin: "192.925px 152.295px",
        }}
      />
      <path
        d="M193.32,151.57a1,1,0,0,1,1-1,1,1,0,0,1,.63.22.22.22,0,0,1,.05.3.21.21,0,0,1-.3,0,.62.62,0,0,0-.38-.13.59.59,0,0,0-.59.58.58.58,0,0,0,.59.57.65.65,0,0,0,.38-.13.21.21,0,1,1,.25.34,1,1,0,0,1-.63.21A1,1,0,0,1,193.32,151.57Z"
        id="elh1m92zobair"
        className="animable"
        style={{
          transformOrigin: "194.179px 151.55px",
        }}
      />
      <path
        d="M195.87,152.27a1,1,0,0,1-.28-.7,1,1,0,0,1,.28-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.9.9,0,0,1-.67.31A.93.93,0,0,1,195.87,152.27Zm.16-.7a.64.64,0,0,0,.14.42.54.54,0,0,0,.39.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.59.59,0,0,0-.39.15A.64.64,0,0,0,196,151.57Z"
        id="el1oo3nw4vflc"
        className="animable"
        style={{
          transformOrigin: "196.55px 151.57px",
        }}
      />
      <path
        d="M198.37,152.27a1,1,0,0,1-.28-.7,1,1,0,0,1,.28-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.9.9,0,0,1-.67.31A.93.93,0,0,1,198.37,152.27Zm.16-.7a.64.64,0,0,0,.14.42.54.54,0,0,0,.39.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.59.59,0,0,0-.39.15A.64.64,0,0,0,198.53,151.57Z"
        id="elwcmuhuhlnk"
        className="animable"
        style={{
          transformOrigin: "199.05px 151.57px",
        }}
      />
      <path
        d="M200.69,153.1v-1.53h0v-.79a.21.21,0,0,1,.21-.22.23.23,0,0,1,.22.17,1,1,0,0,1,.54-.17,1,1,0,0,1,1,1,1,1,0,0,1-1,1,.92.92,0,0,1-.53-.16v.7a.22.22,0,0,1-.23.21A.21.21,0,0,1,200.69,153.1Zm.44-1.53a.55.55,0,0,0,.15.4.5.5,0,0,0,.38.17A.53.53,0,0,0,202,152a.6.6,0,0,0,.15-.4.64.64,0,0,0-.15-.41.57.57,0,0,0-.38-.16.53.53,0,0,0-.38.16A.59.59,0,0,0,201.13,151.57Z"
        id="elmvf42t75reh"
        className="animable"
        style={{
          transformOrigin: "201.675px 151.935px",
        }}
      />
      <path
        d="M203.15,151.56a1,1,0,0,1,1-1,1,1,0,0,1,1,.93v0a.06.06,0,0,1,0,0,.2.2,0,0,1-.21.16H203.6a.55.55,0,0,0,.14.26.57.57,0,0,0,.38.18.64.64,0,0,0,.42-.1.23.23,0,0,1,.3,0,.19.19,0,0,1,0,.26,1,1,0,0,1-.72.26A1,1,0,0,1,203.15,151.56Zm.43-.19h1.13a.66.66,0,0,0-.59-.43A.56.56,0,0,0,203.58,151.37Z"
        id="el9393axnbqb"
        className="animable"
        style={{
          transformOrigin: "204.15px 151.536px",
        }}
      />
      <path
        d="M206.87,150.78a.21.21,0,0,1-.21.21.4.4,0,0,0-.24.07.61.61,0,0,0-.19.2,1.34,1.34,0,0,0-.16.33v.76a.21.21,0,0,1-.22.21.21.21,0,0,1-.21-.21v-1.57a.21.21,0,0,1,.21-.21.21.21,0,0,1,.22.21v0l.08-.08a.93.93,0,0,1,.51-.15A.21.21,0,0,1,206.87,150.78Z"
        id="ele9nogoty2jq"
        className="animable"
        style={{
          transformOrigin: "206.255px 151.555px",
        }}
      />
      <path
        d="M324.22,151.17a.49.49,0,0,1,.48.49.48.48,0,0,1-.48.48.47.47,0,0,1-.48-.48A.48.48,0,0,1,324.22,151.17Z"
        id="elodlvxis30zd"
        className="animable"
        style={{
          transformOrigin: "324.22px 151.655px",
        }}
      />
      <path
        d="M325.71,151.17a.49.49,0,0,1,.49.49.48.48,0,0,1-.49.48.47.47,0,0,1-.48-.48A.48.48,0,0,1,325.71,151.17Z"
        id="eloonrgkzrpq"
        className="animable"
        style={{
          transformOrigin: "325.715px 151.655px",
        }}
      />
      <path
        d="M327.2,151.17a.49.49,0,0,1,.49.49.49.49,0,0,1-1,0A.49.49,0,0,1,327.2,151.17Z"
        id="elqwbgyt7ch0l"
        className="animable"
        style={{
          transformOrigin: "327.19px 151.665px",
        }}
      />
      <path
        d="M177.57,424.39a5,5,0,0,1-1.48.63,5.19,5.19,0,1,1,1.48-.63Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "174.822px 419.987px",
        }}
        id="el101d3gommixi"
        className="animable"
      />
      <path
        d="M176.43,419.42a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,176.43,419.42Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.86px 419.42px",
        }}
        id="els8r53tf4ygq"
        className="animable"
      />
      <path
        d="M177.57,423.75v.64a5,5,0,0,1-1.48.63,5.12,5.12,0,0,1-3.94-.63v-.64a2.71,2.71,0,1,1,5.42,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.86px 423.104px",
        }}
        id="elo3v6299etnm"
        className="animable"
      />
      <path
        d="M184.78,420.59v-2.36A.22.22,0,0,1,185,418a.22.22,0,0,1,.22.22v1.39l.82-.82a.22.22,0,0,1,.31.31l-.6.6.62.74a.22.22,0,0,1,0,.31.22.22,0,0,1-.31,0l-.59-.71-.22.22v.35a.22.22,0,0,1-.22.22A.22.22,0,0,1,184.78,420.59Z"
        id="el0raeki25netg"
        className="animable"
        style={{
          transformOrigin: "185.606px 419.416px",
        }}
      />
      <path
        d="M186.78,419.81a1,1,0,0,1,1-1,1,1,0,0,1,1,.93v0a.06.06,0,0,1,0,0,.19.19,0,0,1-.2.16h-1.28a.55.55,0,0,0,.14.26.57.57,0,0,0,.38.18.64.64,0,0,0,.42-.1.22.22,0,0,1,.3,0,.19.19,0,0,1,0,.26,1,1,0,0,1-.72.26A1,1,0,0,1,186.78,419.81Zm.43-.19h1.14a.67.67,0,0,0-.6-.43A.57.57,0,0,0,187.21,419.62Z"
        id="el207196wjmv5"
        className="animable"
        style={{
          transformOrigin: "187.78px 419.786px",
        }}
      />
      <path
        d="M191,419.65v1a.21.21,0,0,1-.21.21.21.21,0,0,1-.21-.21v-1a.41.41,0,0,0-.41-.41.4.4,0,0,0-.4.41v1a.06.06,0,0,1,0,0,.22.22,0,0,1-.43,0V419a.22.22,0,0,1,.22-.22.21.21,0,0,1,.19.13.78.78,0,0,1,.43-.13A.84.84,0,0,1,191,419.65Z"
        id="el8h1oje5sepv"
        className="animable"
        style={{
          transformOrigin: "190.17px 419.82px",
        }}
      />
      <path
        d="M193.54,420.6a.22.22,0,0,1-.22.21.21.21,0,0,1-.21-.17.91.91,0,0,1-.54.17,1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,.53.17v-.75a.22.22,0,1,1,.44,0v1.58h0Zm-1-1.35a.53.53,0,0,0-.38.16.58.58,0,0,0-.16.41.55.55,0,0,0,.16.39.5.5,0,0,0,.38.17.5.5,0,0,0,.37-.17.55.55,0,0,0,.16-.39.58.58,0,0,0-.16-.41A.52.52,0,0,0,192.57,419.25Z"
        id="el002py6lpjakdy"
        className="animable"
        style={{
          transformOrigin: "192.555px 419.41px",
        }}
      />
      <path
        d="M196.06,419.82v.78a.21.21,0,0,1-.21.21.21.21,0,0,1-.21-.17.88.88,0,0,1-.53.17.91.91,0,0,1-.68-.29,1,1,0,0,1,0-1.41.92.92,0,0,1,.68-.3.89.89,0,0,1,.53.18.21.21,0,0,1,.21-.18.22.22,0,0,1,.21.22Zm-.43,0a.6.6,0,0,0-.15-.41.5.5,0,0,0-.37-.17.5.5,0,0,0-.38.17.6.6,0,0,0-.15.41.62.62,0,0,0,.15.41.52.52,0,0,0,.38.15.51.51,0,0,0,.37-.15A.62.62,0,0,0,195.63,419.82Z"
        id="elemkjkhk4zck"
        className="animable"
        style={{
          transformOrigin: "195.1px 419.81px",
        }}
      />
      <path
        d="M197.15,418a.22.22,0,0,1,.22.22v2.36a.22.22,0,0,1-.44,0v-2.36A.22.22,0,0,1,197.15,418Z"
        id="elm371y9qvuve"
        className="animable"
        style={{
          transformOrigin: "197.15px 419.4px",
        }}
      />
      <path
        d="M198.14,418a.22.22,0,0,1,.23.22v2.36a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22v-2.36A.22.22,0,0,1,198.14,418Z"
        id="elc3kztxylt6"
        className="animable"
        style={{
          transformOrigin: "198.145px 419.4px",
        }}
      />
      <path
        d="M198.42,421.26a.19.19,0,0,1,.19-.18H201a.18.18,0,0,1,.18.18.18.18,0,0,1-.18.19h-2.42A.19.19,0,0,1,198.42,421.26Z"
        id="el9lwtjgzhtlr"
        className="animable"
        style={{
          transformOrigin: "199.8px 421.265px",
        }}
      />
      <path
        d="M202.52,419a.21.21,0,0,1-.21.21.4.4,0,0,0-.24.07.49.49,0,0,0-.18.2,1.14,1.14,0,0,0-.17.33v.76a.21.21,0,0,1-.22.21.21.21,0,0,1-.21-.21V419a.21.21,0,0,1,.21-.21.21.21,0,0,1,.22.21v0l.09-.08a.87.87,0,0,1,.5-.15A.21.21,0,0,1,202.52,419Z"
        id="elb4wvwdy03ik"
        className="animable"
        style={{
          transformOrigin: "201.905px 419.775px",
        }}
      />
      <path
        d="M203.13,420.52a1,1,0,0,1-.28-.7,1,1,0,0,1,.28-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.9.9,0,0,1-.67.31A.93.93,0,0,1,203.13,420.52Zm.16-.7a.64.64,0,0,0,.14.42.54.54,0,0,0,.39.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.59.59,0,0,0-.39.15A.64.64,0,0,0,203.29,419.82Z"
        id="elzlrj6n2034s"
        className="animable"
        style={{
          transformOrigin: "203.81px 419.82px",
        }}
      />
      <path
        d="M205.35,420.24a.21.21,0,0,1,.3,0,.67.67,0,0,0,.44.17.51.51,0,0,0,.27-.07.15.15,0,0,0,.07-.12s0,0,0,0l0,0a1.06,1.06,0,0,0-.32-.11h0a1.6,1.6,0,0,1-.35-.11.62.62,0,0,1-.28-.23.52.52,0,0,1-.07-.25.58.58,0,0,1,.24-.44.91.91,0,0,1,.49-.15,1.08,1.08,0,0,1,.6.22.22.22,0,0,1,.07.3.22.22,0,0,1-.3.06.65.65,0,0,0-.37-.15.4.4,0,0,0-.24.07c-.05,0-.06.07-.06.09s0,0,0,0,0,0,0,0a.69.69,0,0,0,.29.1h0a1.46,1.46,0,0,1,.37.12.61.61,0,0,1,.29.24.59.59,0,0,1,.07.26.58.58,0,0,1-.25.46.89.89,0,0,1-.52.16,1.12,1.12,0,0,1-.71-.27A.22.22,0,0,1,205.35,420.24Z"
        id="elubpa1urd0ys"
        className="animable"
        style={{
          transformOrigin: "206.068px 419.895px",
        }}
      />
      <path
        d="M207.28,420.24a.21.21,0,0,1,.3,0,.67.67,0,0,0,.44.17.51.51,0,0,0,.27-.07.15.15,0,0,0,.07-.12s0,0,0,0l0,0A1.06,1.06,0,0,0,208,420h0a1.69,1.69,0,0,1-.34-.11.62.62,0,0,1-.28-.23.52.52,0,0,1-.07-.25.58.58,0,0,1,.24-.44.91.91,0,0,1,.49-.15,1.08,1.08,0,0,1,.6.22.22.22,0,0,1,.06.3.21.21,0,0,1-.29.06.65.65,0,0,0-.37-.15.4.4,0,0,0-.24.07c-.05,0-.06.07-.06.09v0a.11.11,0,0,0,0,0,.64.64,0,0,0,.29.1h0a1.6,1.6,0,0,1,.37.12.55.55,0,0,1,.28.24.5.5,0,0,1,.08.26.58.58,0,0,1-.25.46.94.94,0,0,1-.52.16,1.12,1.12,0,0,1-.71-.27A.22.22,0,0,1,207.28,420.24Z"
        id="elv2agtvjkrb"
        className="animable"
        style={{
          transformOrigin: "208.002px 419.785px",
        }}
      />
      <path
        d="M324.22,419.42a.49.49,0,0,1,.48.49.48.48,0,0,1-.48.48.47.47,0,0,1-.48-.48A.48.48,0,0,1,324.22,419.42Z"
        id="el3zaf9nvpfp7"
        className="animable"
        style={{
          transformOrigin: "324.22px 419.905px",
        }}
      />
      <path
        d="M325.71,419.42a.49.49,0,0,1,.49.49.48.48,0,0,1-.49.48.47.47,0,0,1-.48-.48A.48.48,0,0,1,325.71,419.42Z"
        id="el02klwru6hkym"
        className="animable"
        style={{
          transformOrigin: "325.715px 419.905px",
        }}
      />
      <path
        d="M327.2,419.42a.49.49,0,0,1,.49.49.49.49,0,0,1-1,0A.49.49,0,0,1,327.2,419.42Z"
        id="elu5gbe9ecf5"
        className="animable"
        style={{
          transformOrigin: "327.19px 419.915px",
        }}
      />
      <path
        d="M176.91,401.3a3.93,3.93,0,0,1-5.89-2.41,3.93,3.93,0,1,1,5.89,2.41Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "174.838px 397.96px",
        }}
        id="elirnyayprodm"
        className="animable"
      />
      <path
        d="M176,397.51a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,176,397.51Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.8px 397.51px",
        }}
        id="elz1tyzmhsot"
        className="animable"
      />
      <path
        d="M176.91,400.81v.49a3.91,3.91,0,0,1-4.14,0v-.49a2.07,2.07,0,1,1,4.14,0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "174.84px 400.316px",
        }}
        id="elsg95bnnkqk"
        className="animable"
      />
      <path
        d="M183.83,397.88h-1.28l-.24.66a.12.12,0,0,1-.09.07h0a.1.1,0,0,1-.06-.12l1-2.6a.11.11,0,0,1,.2,0l1,2.6a.1.1,0,0,1,0,.12h0a.1.1,0,0,1-.09-.07Zm-1.2-.19h1.13l-.57-1.51Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "183.268px 397.218px",
        }}
        id="el59bwd83av1j"
        className="animable"
      />
      <path
        d="M186.31,398.23a1,1,0,1,1,0-1.2v-1.12a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v2.6a.1.1,0,0,1-.09.1.1.1,0,0,1-.1-.1Zm0-.57v-.06a.76.76,0,1,0-1.51,0,.76.76,0,1,0,1.51,0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "185.505px 397.22px",
        }}
        id="elmjjcic6cb2"
        className="animable"
      />
      <path
        d="M189,398.23a1,1,0,1,1,0-1.2v-1.12a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1v2.6a.1.1,0,0,1-.09.1.1.1,0,0,1-.1-.1Zm0-.57v-.06a.76.76,0,1,0-1.51,0,.76.76,0,1,0,1.51,0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "188.195px 397.22px",
        }}
        id="ele4qnezcx7jt"
        className="animable"
      />
      <path
        d="M192.86,396.75v1.76a.1.1,0,0,1-.09.1.1.1,0,0,1-.1-.1v-.29a.93.93,0,0,1-.74.39,1,1,0,0,1,0-2,.92.92,0,0,1,.74.38v-.28a.09.09,0,0,1,.1-.1A.09.09,0,0,1,192.86,396.75Zm-.19.88a.74.74,0,1,0-.74.79A.76.76,0,0,0,192.67,397.63Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "191.903px 397.609px",
        }}
        id="elv6wplvnwm39"
        className="animable"
      />
      <path
        d="M194.75,397.62a1,1,0,0,1,1-1,1.08,1.08,0,0,1,.63.21.1.1,0,0,1-.12.15.82.82,0,0,0-.51-.17.79.79,0,0,0-.81.78.8.8,0,0,0,.81.8.83.83,0,0,0,.51-.18.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.14,1,1,0,0,1-.62.21A1,1,0,0,1,194.75,397.62Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "195.584px 397.59px",
        }}
        id="elnvnseixckf9"
        className="animable"
      />
      <path
        d="M198,396.65a1,1,0,1,1-.92,1A1,1,0,0,1,198,396.65Zm0,1.77a.79.79,0,0,0,0-1.58.79.79,0,0,0,0,1.58Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "198.08px 397.647px",
        }}
        id="elk1rr88pdtnr"
        className="animable"
      />
      <path
        d="M202.42,397.45a.62.62,0,0,0-.61-.61.61.61,0,0,0-.6.61v1.07h0s0,0-.05.06H201v0h0v-1.07a.6.6,0,1,0-1.2,0v1.07a.08.08,0,0,1-.05.07s0,0,0,0h0a.11.11,0,0,1-.08-.07v-1.79a.09.09,0,0,1,.09-.1.09.09,0,0,1,.1.1v.18a.78.78,0,0,1,.6-.28.79.79,0,0,0,1.4,0,.8.8,0,0,1,.8.8v1.07a.1.1,0,0,1-.1.09.1.1,0,0,1-.09-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "201.165px 397.67px",
        }}
        id="elgr5jws3f6gu"
        className="animable"
      />
      <path
        d="M206.23,397.45a.63.63,0,0,0-.61-.61.62.62,0,0,0-.61.61v1.07h0s0,0,0,.06h-.14v0h0v-1.07a.61.61,0,1,0-1.21,0v1.07a.08.08,0,0,1,0,.07h-.07a.14.14,0,0,1-.08-.07v-1.79a.1.1,0,0,1,.09-.1.09.09,0,0,1,.1.1v.18a.79.79,0,0,1,1.3.14.82.82,0,0,1,.71-.42.79.79,0,0,1,.79.8v1.07a.09.09,0,1,1-.18,0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "205.005px 397.67px",
        }}
        id="el4md2y4j5iog"
        className="animable"
      />
      <path
        d="M207.09,397.63a.95.95,0,0,1,1.89-.07h0v0a.08.08,0,0,1-.09.08h-1.61a.77.77,0,0,0,.76.76.73.73,0,0,0,.63-.36.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.13.94.94,0,0,1-.79.45A1,1,0,0,1,207.09,397.63Zm.2-.15h1.48a.75.75,0,0,0-.73-.64A.76.76,0,0,0,207.29,397.48Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "208.035px 397.678px",
        }}
        id="eluo7skpslyda"
        className="animable"
      />
      <path
        d="M211.06,397.45a.61.61,0,0,0-.6-.61.63.63,0,0,0-.61.61v1.08a.11.11,0,0,1-.09.08h0a.15.15,0,0,1-.06-.05v0h0v-1.79a.1.1,0,0,1,.1-.1.1.1,0,0,1,.09.1v.19a.76.76,0,0,1,.61-.29.79.79,0,0,1,.79.8v1.06a.09.09,0,0,1-.09.1.1.1,0,0,1-.1-.1Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "210.495px 397.65px",
        }}
        id="ellrv0o1k0ys"
        className="animable"
      />
      <path
        d="M212.8,396.75a.11.11,0,0,1-.1.09h-.25v1.43a.16.16,0,0,0,.14.14.1.1,0,1,1,0,.2.34.34,0,0,1-.34-.34v-1.43H212c-.1,0-.1,0-.1-.09s0-.1.1-.1h.24v-.73a.1.1,0,0,1,.2,0v.73h.25A.11.11,0,0,1,212.8,396.75Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "212.35px 397.216px",
        }}
        id="el7evmzu1l8q9"
        className="animable"
      />
      <path
        d="M213.87,398.21a.2.2,0,1,1-.2.2A.2.2,0,0,1,213.87,398.21Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "213.87px 398.41px",
        }}
        id="elo6uhjkc2b8a"
        className="animable"
      />
      <path
        d="M214.79,398.21a.2.2,0,1,1-.2.2A.2.2,0,0,1,214.79,398.21Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "214.79px 398.41px",
        }}
        id="elbrtoh3djpyl"
        className="animable"
      />
      <path
        d="M215.71,398.21a.2.2,0,1,1-.2.2A.2.2,0,0,1,215.71,398.21Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "215.71px 398.41px",
        }}
        id="elpsezy70fgs"
        className="animable"
      />
      <path
        d="M173,406.46h-1.52l-.06,0a.1.1,0,0,1,0-.14l1.62-2h0a.09.09,0,0,1,.13,0,.05.05,0,0,1,0,.05h0v1.93h.19a.1.1,0,1,1,0,.2h-.19v.48a.1.1,0,0,1-.2,0Zm0-.2v-1.63l-1.32,1.63Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "172.426px 405.686px",
        }}
        id="ellfgn5yv71w"
        className="animable"
      />
      <path
        d="M176.85,405.84a.63.63,0,0,0-1.25,0v1.1h0v0a.1.1,0,0,1-.06,0h0a.11.11,0,0,1-.07,0l0,0v-2.64a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1v1a.83.83,0,0,1,.62-.29.78.78,0,0,1,.82.77v1.1a.09.09,0,0,1-.1.09.09.09,0,0,1-.09-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "176.285px 405.585px",
        }}
        id="elghdi821vc7"
        className="animable"
      />
      <path
        d="M178.69,405.07a1,1,0,1,1-.92,1A1,1,0,0,1,178.69,405.07Zm0,1.77a.79.79,0,1,0-.73-.79A.76.76,0,0,0,178.69,406.84Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "178.77px 406.067px",
        }}
        id="elczleu20d3rm"
        className="animable"
      />
      <path
        d="M180.26,405.17a.09.09,0,0,1,.09-.1.1.1,0,0,1,.1.1v1.06a.6.6,0,1,0,1.2,0v-1.06a.1.1,0,0,1,.1-.1.09.09,0,0,1,.1.1v1.06a.8.8,0,0,1-.8.8.79.79,0,0,1-.79-.8Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "181.055px 406.05px",
        }}
        id="eluar5s9qz4w"
        className="animable"
      />
      <path
        d="M182.75,405.17a.09.09,0,0,1,.1-.09.1.1,0,0,1,.09.09v.44s0,0,0-.05a.93.93,0,0,1,.78-.48.1.1,0,0,1,.1.09.11.11,0,0,1-.1.1.7.7,0,0,0-.57.32,1.57,1.57,0,0,0-.23.45.08.08,0,0,0,0,0v.86a.1.1,0,0,1-.09.09.09.09,0,0,1-.1-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "183.275px 406.035px",
        }}
        id="elzxbvzkz0hx"
        className="animable"
      />
      <path
        d="M184.37,406.63a.09.09,0,0,1,.13,0,1.06,1.06,0,0,0,.6.23.58.58,0,0,0,.37-.12.28.28,0,0,0,.15-.24.3.3,0,0,0-.14-.24,1,1,0,0,0-.41-.14h0a1.14,1.14,0,0,1-.45-.15.41.41,0,0,1-.21-.35.48.48,0,0,1,.21-.38.85.85,0,0,1,.48-.14,1,1,0,0,1,.59.22.11.11,0,0,1,0,.13.11.11,0,0,1-.14,0,.8.8,0,0,0-.48-.2.58.58,0,0,0-.37.12.28.28,0,0,0-.12.22.24.24,0,0,0,.11.2,1.24,1.24,0,0,0,.4.13h0a1.24,1.24,0,0,1,.47.16.48.48,0,0,1,.22.4.51.51,0,0,1-.22.4.81.81,0,0,1-.49.15,1.16,1.16,0,0,1-.72-.28A.08.08,0,0,1,184.37,406.63Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "185.056px 406.065px",
        }}
        id="elanumd2vjs5t"
        className="animable"
      />
      <path
        d="M189.31,405.17v1.77a.09.09,0,0,1-.09.09.1.1,0,0,1-.1-.09v-.3a.89.89,0,0,1-.73.39,1,1,0,0,1,0-2,.89.89,0,0,1,.73.39v-.29a.1.1,0,0,1,.1-.1A.09.09,0,0,1,189.31,405.17Zm-.19.88a.76.76,0,0,0-.73-.79.79.79,0,0,0,0,1.58A.76.76,0,0,0,189.12,406.05Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "188.358px 406.029px",
        }}
        id="elsw4vhnwyioi"
        className="animable"
      />
      <path
        d="M192,406.88a.93.93,0,0,1-.93.92.91.91,0,0,1-.4-.1.09.09,0,0,1,0-.12.08.08,0,0,1,.12-.05.68.68,0,0,0,.32.07.73.73,0,0,0,.74-.72v-.24a.92.92,0,0,1-.74.38,1,1,0,0,1,0-1.95.91.91,0,0,1,.74.39v-.29a.1.1,0,0,1,.1-.1.11.11,0,0,1,.09.1Zm-.19-.84a.73.73,0,1,0-1.46,0,.73.73,0,1,0,1.46,0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "191.186px 406.435px",
        }}
        id="elf5pcgfr7s9t"
        className="animable"
      />
      <path
        d="M193.76,405.07a1,1,0,1,1-.93,1A1,1,0,0,1,193.76,405.07Zm0,1.77a.79.79,0,1,0-.73-.79A.76.76,0,0,0,193.76,406.84Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "193.83px 406.068px",
        }}
        id="elpog6pg3u4bj"
        className="animable"
      />
      <path
        d="M172.15,379a.22.22,0,0,1-.22.22h-.1v1.12a.22.22,0,0,1,.22.22.22.22,0,0,1-.22.22.45.45,0,0,1-.45-.44v-1.12h-.11a.22.22,0,1,1,0-.44h.11v-.58a.22.22,0,0,1,.23-.22.22.22,0,0,1,.22.22v.58h.1A.22.22,0,0,1,172.15,379Z"
        id="ela3mwghkyjon"
        className="animable"
        style={{
          transformOrigin: "171.6px 379.38px",
        }}
      />
      <path
        d="M173,380.5a1,1,0,0,1-.27-.7,1,1,0,0,1,.27-.7,1,1,0,0,1,.69-.31.87.87,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.86.86,0,0,1-.67.3A.94.94,0,0,1,173,380.5Zm.16-.7a.65.65,0,0,0,.15.42.52.52,0,0,0,.38.15.51.51,0,0,0,.37-.15.63.63,0,0,0,0-.84.56.56,0,0,0-.37-.15.56.56,0,0,0-.38.15A.65.65,0,0,0,173.13,379.8Z"
        id="elbp7pmlj8v5b"
        className="animable"
        style={{
          transformOrigin: "173.685px 379.795px",
        }}
      />
      <path
        d="M177,379.62h0v.95a.21.21,0,0,1-.21.21.22.22,0,0,1-.22-.21v-.95h0a.4.4,0,0,0-.41-.4.41.41,0,0,0-.4.41v1h0s0,0,0,0v0a.21.21,0,0,1-.2.13h0a.23.23,0,0,1-.17-.21v-.95h0V379a.22.22,0,0,1,.21-.22.2.2,0,0,1,.19.12.93.93,0,0,1,.43-.12.85.85,0,0,0,1.26,0,.84.84,0,0,1,.83.84v.95a.21.21,0,0,1-.21.21.21.21,0,0,1-.22-.21v-.95a.41.41,0,0,0-.4-.41A.42.42,0,0,0,177,379.62Z"
        id="el4pzkbfzzpp8"
        className="animable"
        style={{
          transformOrigin: "176.85px 379.78px",
        }}
      />
      <path
        d="M179.35,380.22a.31.31,0,0,1,.3.3.3.3,0,0,1-.3.3.29.29,0,0,1-.3-.3A.3.3,0,0,1,179.35,380.22Z"
        id="el6peur334ap8"
        className="animable"
        style={{
          transformOrigin: "179.35px 380.52px",
        }}
      />
      <path
        d="M179.79,379.8a1,1,0,0,1,1-1,1,1,0,0,1,.63.22.22.22,0,0,1,.05.3.21.21,0,0,1-.3,0,.6.6,0,0,0-1,.45.59.59,0,0,0,.59.57.62.62,0,0,0,.38-.13.21.21,0,1,1,.25.34,1,1,0,0,1-.63.21A1,1,0,0,1,179.79,379.8Z"
        id="elq3bye3wfugn"
        className="animable"
        style={{
          transformOrigin: "180.649px 379.78px",
        }}
      />
      <path
        d="M182.34,380.5a1,1,0,0,1-.27-.7,1,1,0,0,1,.27-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.89.89,0,0,1-.67.3A.92.92,0,0,1,182.34,380.5Zm.16-.7a.6.6,0,0,0,.15.42.52.52,0,0,0,.38.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.56.56,0,0,0-.38.15A.6.6,0,0,0,182.5,379.8Z"
        id="elcsb4t21gdfq"
        className="animable"
        style={{
          transformOrigin: "183.025px 379.795px",
        }}
      />
      <path
        d="M184.84,380.5a1,1,0,0,1-.27-.7,1,1,0,0,1,.27-.7.93.93,0,0,1,.69-.31.9.9,0,0,1,.67.31,1,1,0,0,1,.28.7,1,1,0,0,1-.28.7.89.89,0,0,1-.67.3A.92.92,0,0,1,184.84,380.5Zm.16-.7a.6.6,0,0,0,.15.42.52.52,0,0,0,.38.15.51.51,0,0,0,.37-.15.66.66,0,0,0,0-.84.56.56,0,0,0-.37-.15.56.56,0,0,0-.38.15A.6.6,0,0,0,185,379.8Z"
        id="eld2ecjlsd4co"
        className="animable"
        style={{
          transformOrigin: "185.525px 379.795px",
        }}
      />
      <path
        d="M187.16,381.33V379.8h0V379a.21.21,0,0,1,.21-.22.23.23,0,0,1,.22.17,1,1,0,1,1,.54,1.83.92.92,0,0,1-.53-.16v.7a.22.22,0,0,1-.23.21A.21.21,0,0,1,187.16,381.33Zm.44-1.53a.55.55,0,0,0,.15.4.51.51,0,0,0,.76,0,.6.6,0,0,0,.16-.4.65.65,0,0,0-.16-.41.53.53,0,0,0-.76,0A.59.59,0,0,0,187.6,379.8Z"
        id="el1q0kghwvtzc"
        className="animable"
        style={{
          transformOrigin: "188.154px 380.155px",
        }}
      />
      <path
        d="M189.62,379.79a1,1,0,0,1,1-1,1,1,0,0,1,1,.93v0a.06.06,0,0,1,0,0,.19.19,0,0,1-.21.16h-1.27a.55.55,0,0,0,.14.26.57.57,0,0,0,.38.18.64.64,0,0,0,.42-.1.23.23,0,0,1,.3,0,.19.19,0,0,1,0,.26,1,1,0,0,1-.72.26A1,1,0,0,1,189.62,379.79Zm.43-.19h1.13a.66.66,0,0,0-.59-.43A.57.57,0,0,0,190.05,379.6Z"
        id="elnsdgs4g1w0e"
        className="animable"
        style={{
          transformOrigin: "190.62px 379.766px",
        }}
      />
      <path
        d="M193.34,379a.21.21,0,0,1-.21.21.4.4,0,0,0-.24.07.49.49,0,0,0-.18.2,1.14,1.14,0,0,0-.17.33v.76a.21.21,0,0,1-.22.21.21.21,0,0,1-.21-.21V379a.21.21,0,0,1,.21-.21.21.21,0,0,1,.22.21v0l.09-.08a.87.87,0,0,1,.5-.15A.21.21,0,0,1,193.34,379Z"
        id="el8vs9cxp0r74"
        className="animable"
        style={{
          transformOrigin: "192.725px 379.775px",
        }}
      />
      <path
        d="M196.63,380h-.4a.09.09,0,1,1,0-.18h.43l.17-.95h-.44a.09.09,0,1,1,0-.18h.47l.11-.66a.1.1,0,0,1,.1-.09.09.09,0,0,1,.09.11l-.11.64h.83l.11-.66a.1.1,0,0,1,.1-.09.09.09,0,0,1,.09.11l-.11.64h.4a.09.09,0,1,1,0,.18H198l-.16.95h.43a.09.09,0,1,1,0,.18h-.47l-.11.68a.11.11,0,0,1-.1.09.09.09,0,0,1-.09-.12l.11-.65h-.83l-.11.68a.11.11,0,0,1-.1.09.09.09,0,0,1-.09-.12Zm1.05-.18.17-.95H197l-.16.95Z"
        id="elov5uwy03eup"
        className="animable"
        style={{
          transformOrigin: "197.35px 379.355px",
        }}
      />
      <path
        d="M199.89,378.19h-.84a.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1h1.88a.1.1,0,0,1,.09.1.09.09,0,0,1-.09.1h-.85v2.51a.09.09,0,0,1-.09.09.1.1,0,0,1-.1-.09Z"
        id="el3h1lp6bppev"
        className="animable"
        style={{
          transformOrigin: "199.985px 379.39px",
        }}
      />
      <path
        d="M201.76,378.09a.1.1,0,0,1,.1-.1h.62a.71.71,0,0,1,.7.7.72.72,0,0,1-.27.55.81.81,0,0,1,.55.75.8.8,0,0,1-.8.8h-.81a.09.09,0,0,1-.09-.09Zm.72,1.1a.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5H202v1Zm.18,1.41a.61.61,0,0,0,0-1.21H202v1.21Z"
        id="elf7lw09sq0ck"
        className="animable"
        style={{
          transformOrigin: "202.61px 379.39px",
        }}
      />
      <path
        d="M204.78,378.19h-.84a.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1h1.88a.1.1,0,0,1,.09.1.09.09,0,0,1-.09.1H205v2.51a.09.09,0,0,1-.09.09.09.09,0,0,1-.1-.09Z"
        id="elqsm0cvlx4fn"
        className="animable"
        style={{
          transformOrigin: "204.875px 379.39px",
        }}
      />
      <path
        d="M209.05,378.09a.1.1,0,0,1,.09-.1h1.44a.1.1,0,0,1,.1.1.09.09,0,0,1-.1.1h-1.34v1.11h1.18a.09.09,0,0,1,.09.1.09.09,0,0,1-.09.09h-1.18v1.11h1.34a.09.09,0,0,1,.1.1.09.09,0,0,1-.1.09h-1.44a.09.09,0,0,1-.09-.09Z"
        id="el6ws7mqxww5d"
        className="animable"
        style={{
          transformOrigin: "209.865px 379.39px",
        }}
      />
      <path
        d="M212.78,379.63a.6.6,0,0,0-.61-.6.62.62,0,0,0-.61.6v1.07h0a.06.06,0,0,1,0,.05.08.08,0,0,1-.07,0h0s0,0-.07-.05h0v-1.79a.09.09,0,0,1,.18,0v.19a.82.82,0,0,1,.61-.28.8.8,0,0,1,.8.79v1.07a.1.1,0,0,1-.1.09.09.09,0,0,1-.09-.09Z"
        id="elhg3z4olhdrl"
        className="animable"
        style={{
          transformOrigin: "212.215px 379.795px",
        }}
      />
      <path
        d="M213.53,381.36a.15.15,0,0,0,.15-.14v-2.29a.1.1,0,0,1,.1-.1.1.1,0,0,1,.09.1v2.29a.34.34,0,0,1-.34.34.09.09,0,0,1-.09-.1A.1.1,0,0,1,213.53,381.36Zm.15-3.07a.12.12,0,0,1,.1-.1.1.1,0,0,1,.1.1v.09a.1.1,0,0,1-.1.1.12.12,0,0,1-.1-.1Z"
        id="el395wanzv7r4"
        className="animable"
        style={{
          transformOrigin: "213.66px 379.875px",
        }}
      />
      <path
        d="M215.66,378.83a1,1,0,1,1-.93,1A1,1,0,0,1,215.66,378.83Zm0,1.77a.79.79,0,1,0-.74-.79A.77.77,0,0,0,215.66,380.6Z"
        id="elv7dutr1vw3a"
        className="animable"
        style={{
          transformOrigin: "215.73px 379.828px",
        }}
      />
      <path
        d="M217.34,378.93a.09.09,0,0,1,.09-.1.09.09,0,0,1,.1.1V380a.61.61,0,0,0,1.21,0v-1.06s0,0,0-.05h0l0,0h0l.05,0s0,0,0,0,0,0,0,0v1.71a.92.92,0,0,1-.93.92.91.91,0,0,1-.4-.1.08.08,0,0,1,0-.12.1.1,0,0,1,.12,0,.71.71,0,0,0,.32.07.73.73,0,0,0,.74-.72v-.13a.79.79,0,0,1-1.4-.52Z"
        id="elbofuw1f1izi"
        className="animable"
        style={{
          transformOrigin: "218.015px 380.175px",
        }}
      />
      <path
        d="M219.86,378.29a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v.09a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11Zm0,.64a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v1.77a.1.1,0,0,1-.1.09.09.09,0,0,1-.1-.09Z"
        id="elqzcd2u0akba"
        className="animable"
        style={{
          transformOrigin: "219.96px 379.49px",
        }}
      />
      <path
        d="M222.38,379.63a.6.6,0,0,0-.6-.6.61.61,0,0,0-.61.6v1.07h0l0,.05a.11.11,0,0,1-.07,0h0s-.05,0-.06-.05h0v-1.79a.09.09,0,0,1,.1-.09.09.09,0,0,1,.09.09v.19a.79.79,0,0,1,1.4.51v1.07a.09.09,0,0,1-.09.09.09.09,0,0,1-.1-.09Z"
        id="el93l6zamlfm4"
        className="animable"
        style={{
          transformOrigin: "221.835px 379.791px",
        }}
      />
      <path
        d="M225.14,380.64a.92.92,0,0,1-.92.92,1,1,0,0,1-.41-.1.1.1,0,0,1,0-.12c0-.06.08-.08.13,0a.68.68,0,0,0,.32.07.72.72,0,0,0,.73-.72v-.24a.89.89,0,0,1-.73.38,1,1,0,0,1,0-1.95.9.9,0,0,1,.73.39v-.29a.11.11,0,0,1,.1-.1.1.1,0,0,1,.09.1Zm-.19-.84a.73.73,0,1,0-1.46,0,.73.73,0,1,0,1.46,0Z"
        id="el97yw74s4drv"
        className="animable"
        style={{
          transformOrigin: "224.331px 380.22px",
        }}
      />
      <path
        d="M228.67,379.63a.6.6,0,0,0-.6-.6.62.62,0,0,0-.61.6v1.07h0s0,0,0,.05a.09.09,0,0,1-.07,0h0s-.05,0-.06-.05h0v-1.79a.09.09,0,0,1,.1-.09.09.09,0,0,1,.09.09v.19a.79.79,0,0,1,1.4.51v1.07a.09.09,0,0,1-.09.09.1.1,0,0,1-.1-.09Z"
        id="eli1mevfb14un"
        className="animable"
        style={{
          transformOrigin: "228.125px 379.791px",
        }}
      />
      <path
        d="M231.37,378.93v1.77a.1.1,0,0,1-.1.09.09.09,0,0,1-.09-.09v-.3a.91.91,0,0,1-.74.39,1,1,0,0,1,0-2,.93.93,0,0,1,.74.39v-.29a.09.09,0,0,1,.09-.1A.1.1,0,0,1,231.37,378.93Zm-.19.88a.74.74,0,1,0-.74.79A.77.77,0,0,0,231.18,379.81Z"
        id="elis58e6y365h"
        className="animable"
        style={{
          transformOrigin: "230.409px 379.79px",
        }}
      />
      <path
        d="M232.88,378.93a.1.1,0,0,1-.09.1h-.25v1.42a.15.15,0,0,0,.14.15.1.1,0,1,1,0,.19.33.33,0,0,1-.34-.34V379h-.25c-.09,0-.09,0-.09-.1s0-.1.09-.1h.25v-.72a.1.1,0,0,1,.09-.1.12.12,0,0,1,.11.1v.72h.25A.1.1,0,0,1,232.88,378.93Z"
        id="eltaaenfx3ccc"
        className="animable"
        style={{
          transformOrigin: "232.442px 379.387px",
        }}
      />
      <path
        d="M233.76,378.93a.09.09,0,0,1,.1-.1.09.09,0,0,1,.09.1V380a.61.61,0,1,0,1.21,0v-1.06a.1.1,0,0,1,.2,0V380a.8.8,0,0,1-.81.8.79.79,0,0,1-.79-.8Z"
        id="el5sa6jth1k44"
        className="animable"
        style={{
          transformOrigin: "234.56px 379.815px",
        }}
      />
      <path
        d="M236.25,378.93a.1.1,0,0,1,.1-.09.09.09,0,0,1,.09.09v.44l0-.05a1,1,0,0,1,.79-.48.09.09,0,0,1,.09.09.09.09,0,0,1-.09.1.69.69,0,0,0-.57.32,2,2,0,0,0-.24.45.08.08,0,0,0,0,0v.86a.09.09,0,0,1-.09.09.1.1,0,0,1-.1-.09Z"
        id="elgrza5yzepsl"
        className="animable"
        style={{
          transformOrigin: "236.775px 379.795px",
        }}
      />
      <path
        d="M237.67,379.82a.95.95,0,1,1,1.89-.07h0a.09.09,0,0,1-.09.09h-1.61a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.36.11.11,0,0,1,.13,0,.11.11,0,0,1,0,.14.93.93,0,0,1-.79.44A1,1,0,0,1,237.67,379.82Zm.2-.16h1.49a.76.76,0,0,0-1.49,0Z"
        id="elgyio8qvegzo"
        className="animable"
        style={{
          transformOrigin: "238.612px 379.777px",
        }}
      />
      <path
        d="M240.24,378.09a.11.11,0,0,1,.1-.1.1.1,0,0,1,.1.1v2a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1Zm0,2.51a.11.11,0,0,1,.1-.1.1.1,0,0,1,.1.1v.1a.09.09,0,0,1-.1.09.1.1,0,0,1-.1-.09Z"
        id="ellr3a6lp2wip"
        className="animable"
        style={{
          transformOrigin: "240.34px 379.39px",
        }}
      />
      <path
        d="M172.61,388.71h0l-1.08-2.57a.1.1,0,0,1,0-.13.1.1,0,0,1,.13,0l1,2.39,1-2.39a.09.09,0,0,1,.12,0,.1.1,0,0,1,.06.13l-1.09,2.55a.08.08,0,0,1,0,.08h-.08A.06.06,0,0,1,172.61,388.71Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "172.676px 387.378px",
        }}
        id="elgcrl4tnkc5"
        className="animable"
      />
      <path
        d="M174.57,386.27a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v.09a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1Zm0,.64a.09.09,0,0,1,.1-.1.1.1,0,0,1,.1.1v1.77a.1.1,0,0,1-.1.09.09.09,0,0,1-.1-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "174.67px 387.47px",
        }}
        id="elohhrr6jqcnb"
        className="animable"
      />
      <path
        d="M175.55,387.8a1,1,0,0,1,.95-1,1,1,0,0,1,.94.91h0a.09.09,0,0,1-.09.09h-1.61a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.36.11.11,0,0,1,.13,0,.11.11,0,0,1,0,.14.92.92,0,0,1-.79.44A1,1,0,0,1,175.55,387.8Zm.2-.16h1.49a.77.77,0,0,0-.74-.64A.78.78,0,0,0,175.75,387.64Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "176.495px 387.785px",
        }}
        id="elmvmymni2ils"
        className="animable"
      />
      <path
        d="M178.68,388.75s0,0,0,0l-.73-1.75a.09.09,0,0,1,0-.12.1.1,0,0,1,.13.05l.65,1.54.45-1.07a.11.11,0,0,1,.09-.06.11.11,0,0,1,.1.06l.45,1.07.65-1.54a.09.09,0,0,1,.12-.05.09.09,0,0,1,0,.12l-.73,1.74,0,.05,0,0h0a.1.1,0,0,1-.08-.06h0l-.46-1.09-.45,1.08h0a.09.09,0,0,1-.09.06h0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "179.27px 387.831px",
        }}
        id="el0c6a7gtp2ns"
        className="animable"
      />
      <path
        d="M184.31,386.91v1.77a.09.09,0,0,1-.09.09.1.1,0,0,1-.1-.09v-.3a.89.89,0,0,1-.73.39,1,1,0,0,1,0-2,.89.89,0,0,1,.73.39v-.29a.1.1,0,0,1,.1-.1A.09.09,0,0,1,184.31,386.91Zm-.19.88a.76.76,0,0,0-.73-.79.79.79,0,0,0,0,1.58A.76.76,0,0,0,184.12,387.79Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "183.358px 387.769px",
        }}
        id="elgvs26ek869p"
        className="animable"
      />
      <path
        d="M185.23,386.07a.1.1,0,0,1,.1-.1.11.11,0,0,1,.1.1v2.61a.1.1,0,0,1-.1.09.09.09,0,0,1-.1-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "185.33px 387.37px",
        }}
        id="elfpavc227pca"
        className="animable"
      />
      <path
        d="M186.23,386.07a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1v2.61a.09.09,0,0,1-.1.09.09.09,0,0,1-.09-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "186.325px 387.37px",
        }}
        id="elny29g7cudpm"
        className="animable"
      />
      <path
        d="M188.24,388.6l1.3-1.18a.71.71,0,0,0,.24-.54.72.72,0,0,0-1.2-.53l-.14.13a.1.1,0,0,1-.13-.14l.14-.13a.91.91,0,0,1,1.29.06.92.92,0,0,1,.24.61.91.91,0,0,1-.3.68l-1.12,1h1.32a.1.1,0,0,1,.1.1.1.1,0,0,1-.1.09h-1.57a.11.11,0,0,1-.08,0A.11.11,0,0,1,188.24,388.6Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "189.093px 387.364px",
        }}
        id="elw1vxp6a7pcq"
        className="animable"
      />
      <path
        d="M192.08,388.2h-1.52l-.06,0a.09.09,0,0,1,0-.14l1.61-2h0a.09.09,0,0,1,.13,0,.1.1,0,0,1,0,.05h0V388h.19a.1.1,0,1,1,0,.2h-.19v.48a.09.09,0,0,1-.1.09.1.1,0,0,1-.1-.09Zm0-.2v-1.64L190.76,388Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "191.498px 387.401px",
        }}
        id="el02ow6w2v6wm7"
        className="animable"
      />
      <path
        d="M193.45,386.58a1.13,1.13,0,0,1,1-.6s.09,0,.09.09a.09.09,0,0,1-.09.1,1,1,0,0,0-.82.51,2,2,0,0,0-.2.56.94.94,0,0,1,.7-.32.93.93,0,1,1-.93,1,1.09,1.09,0,0,1,0-.18A2.33,2.33,0,0,1,193.45,386.58Zm-.07,1.28a.13.13,0,0,0,0,.06s0,0,0,0a.74.74,0,0,0,.73.64.73.73,0,1,0-.73-.73Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "194.127px 387.38px",
        }}
        id="el5n77s6cjulo"
        className="animable"
      />
      <path
        d="M196.92,387.79a1,1,0,0,1,1-1,1,1,0,0,1,.62.22.09.09,0,0,1,0,.13.09.09,0,0,1-.13,0,.77.77,0,0,0-.5-.18.79.79,0,1,0,0,1.58.82.82,0,0,0,.5-.17.1.1,0,0,1,.13,0,.09.09,0,0,1,0,.14,1,1,0,0,1-1.62-.77Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "197.747px 387.758px",
        }}
        id="eljkcavtrele"
        className="animable"
      />
      <path
        d="M200.12,386.81a1,1,0,1,1-.93,1A1,1,0,0,1,200.12,386.81Zm0,1.77a.79.79,0,0,0,0-1.58.79.79,0,0,0,0,1.58Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "200.19px 387.808px",
        }}
        id="elgjh6e61fj84"
        className="animable"
      />
      <path
        d="M204.58,387.61a.61.61,0,1,0-1.21,0v1.07h0a.12.12,0,0,1-.05.05h-.08l0,0h0v-1.07a.61.61,0,1,0-1.21,0v1.07a.08.08,0,0,1,0,.07l0,0h0a.09.09,0,0,1-.08-.07v-1.79a.1.1,0,0,1,.09-.09.09.09,0,0,1,.1.09v.19a.75.75,0,0,1,.6-.28.77.77,0,0,1,.7.41.81.81,0,0,1,.71-.41.79.79,0,0,1,.79.79v1.07a.09.09,0,0,1-.09.09.09.09,0,0,1-.1-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "203.445px 387.825px",
        }}
        id="elt8f2dzmry5"
        className="animable"
      />
      <path
        d="M208.39,387.61a.62.62,0,0,0-.61-.61.61.61,0,0,0-.6.61v1.07h0a.12.12,0,0,1,0,.05h-.07l0,0h0v-1.07a.61.61,0,1,0-1.21,0v1.07a.07.07,0,0,1,0,.07l0,0h0a.08.08,0,0,1-.08-.07v-1.79a.09.09,0,0,1,.18,0v.19a.77.77,0,0,1,.61-.28.8.8,0,0,0,1.4,0,.79.79,0,0,1,.8.79v1.07a.09.09,0,0,1-.1.09.09.09,0,0,1-.09-.09Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "207.315px 387.825px",
        }}
        id="elgdxzhzegq2c"
        className="animable"
      />
      <path
        d="M209.25,387.8a.95.95,0,1,1,1.89-.08h0a.09.09,0,0,1-.09.09h-1.61a.77.77,0,0,0,.76.75.73.73,0,0,0,.63-.36.11.11,0,0,1,.13,0,.11.11,0,0,1,0,.14.93.93,0,0,1-.79.44A1,1,0,0,1,209.25,387.8Zm.2-.16h1.49a.77.77,0,0,0-.74-.64A.78.78,0,0,0,209.45,387.64Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "210.191px 387.751px",
        }}
        id="elib3490js7i"
        className="animable"
      />
      <path
        d="M213.22,387.61a.6.6,0,0,0-.6-.6.62.62,0,0,0-.61.6v1.07h0a.06.06,0,0,1,0,.05.08.08,0,0,1-.07,0h0a.18.18,0,0,1-.07,0h0v-1.79a.09.09,0,0,1,.18,0v.19a.82.82,0,0,1,.61-.28.8.8,0,0,1,.8.79v1.07a.1.1,0,0,1-.2,0Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "212.665px 387.83px",
        }}
        id="elfxdx8pk0uo"
        className="animable"
      />
      <path
        d="M215,386.91a.1.1,0,0,1-.1.09h-.25v1.43a.16.16,0,0,0,.15.15.1.1,0,1,1,0,.19.33.33,0,0,1-.35-.34V387h-.24c-.1,0-.1,0-.1-.09s0-.1.1-.1h.24v-.73a.1.1,0,0,1,.2,0v.73h.25A.11.11,0,0,1,215,386.91Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "214.555px 387.377px",
        }}
        id="el79nwtz6is22"
        className="animable"
      />
      <path
        d="M215.74,388.36a.11.11,0,0,1,.14,0,1,1,0,0,0,.6.23.61.61,0,0,0,.37-.12.31.31,0,0,0,.15-.24.32.32,0,0,0-.14-.24,1.08,1.08,0,0,0-.42-.14h0a1.09,1.09,0,0,1-.44-.15.41.41,0,0,1-.21-.35.51.51,0,0,1,.21-.39.85.85,0,0,1,.48-.13,1.08,1.08,0,0,1,.58.21.1.1,0,0,1,0,.14.1.1,0,0,1-.13,0,.86.86,0,0,0-.48-.2.63.63,0,0,0-.37.11.32.32,0,0,0-.13.23.23.23,0,0,0,.12.19,1,1,0,0,0,.39.14h0a1.36,1.36,0,0,1,.48.16.48.48,0,0,1,.22.4.5.5,0,0,1-.23.4.83.83,0,0,1-.48.15,1.16,1.16,0,0,1-.73-.28A.09.09,0,0,1,215.74,388.36Z"
        style={{
          fill: "rgb(166, 166, 166)",
          transformOrigin: "216.433px 387.795px",
        }}
        id="elnih8wh43e1"
        className="animable"
      />
      <path
        d="M172.65,372.78a1,1,0,0,1-.7,1.7,1,1,0,0,1-.7-.29.23.23,0,1,1,.32-.32.56.56,0,0,0,.76,0,.54.54,0,0,0,.16-.39.52.52,0,0,0-.16-.38.59.59,0,0,0-.38-.16.17.17,0,0,1-.16-.07h0a.22.22,0,0,1,0-.32l.41-.42h-.65a.23.23,0,1,1,0-.45h1.18a.22.22,0,0,1,.22.23.3.3,0,0,1,0,.1l0,.06-.51.52A.92.92,0,0,1,172.65,372.78Z"
        id="el9vtxak61r09"
        className="animable"
        style={{
          transformOrigin: "172.053px 373.077px",
        }}
      />
      <path
        d="M173.94,373.92a.3.3,0,1,1,0,.59.3.3,0,0,1,0-.59Z"
        id="el9wzaxu9i9vp"
        className="animable"
        style={{
          transformOrigin: "173.995px 374.215px",
        }}
      />
      <path
        d="M174.42,373.08a1.64,1.64,0,0,1,.27-.95.89.89,0,0,1,.74-.44.88.88,0,0,1,.74.44,1.71,1.71,0,0,1,.27.95,1.75,1.75,0,0,1-.27,1,.9.9,0,0,1-.74.44.92.92,0,0,1-.74-.44A1.67,1.67,0,0,1,174.42,373.08Zm1.58,0a1.27,1.27,0,0,0-.2-.71.47.47,0,0,0-.37-.24.51.51,0,0,0-.38.24,1.35,1.35,0,0,0-.19.71,1.33,1.33,0,0,0,.19.71.5.5,0,0,0,.38.25.46.46,0,0,0,.37-.25A1.24,1.24,0,0,0,176,373.08Z"
        id="elmm627uo8esj"
        className="animable"
        style={{
          transformOrigin: "175.429px 373.105px",
        }}
      />
      <path
        d="M179.4,373.74a.22.22,0,0,1-.23.22h0v.3a.21.21,0,0,1-.22.22.22.22,0,0,1-.22-.22V374h-1.26a.18.18,0,0,1-.13,0,.22.22,0,0,1,0-.31l1.48-1.84h0v0H179l0,0h0l0,0h0l0,0v1.73h0A.22.22,0,0,1,179.4,373.74Zm-.71-1.21-.79,1h.79Z"
        id="el7ig9w4p1i2w"
        className="animable"
        style={{
          transformOrigin: "178.34px 373.165px",
        }}
      />
      <path
        d="M181.39,372.79a1,1,0,0,1,.29.7,1,1,0,0,1-.29.7,1,1,0,0,1-.7.29h0a.92.92,0,0,1-.69-.29.21.21,0,0,1,0-.32.22.22,0,0,1,.32,0,.53.53,0,0,0,.76,0,.55.55,0,0,0,.16-.38.54.54,0,0,0-.92-.38.22.22,0,0,1-.32,0s0,0-.05-.05V373h0v-.07l.12-1a.23.23,0,0,1,.1-.15h0a.16.16,0,0,1,.1,0h1.18a.22.22,0,0,1,.23.22.23.23,0,0,1-.23.23h-1l-.05.39.27,0A1,1,0,0,1,181.39,372.79Z"
        id="elni5zayr3bij"
        className="animable"
        style={{
          transformOrigin: "180.803px 373.126px",
        }}
      />
      <path
        d="M183.89,371.69a.22.22,0,0,1,.23.22v2.35a.22.22,0,0,1-.23.22.22.22,0,0,1-.22-.22v-2.35A.22.22,0,0,1,183.89,371.69Z"
        id="elu1usu2hxuvp"
        className="animable"
        style={{
          transformOrigin: "183.895px 373.085px",
        }}
      />
      <path
        d="M185.08,372a.22.22,0,1,1-.43,0v-.09a.21.21,0,0,1,.21-.21.21.21,0,0,1,.22.21Zm0,.72v1.56a.21.21,0,0,1-.22.21.21.21,0,0,1-.21-.21v-1.56a.21.21,0,0,1,.21-.22A.21.21,0,0,1,185.08,372.71Z"
        id="elkf8jw8kvhvn"
        className="animable"
        style={{
          transformOrigin: "184.865px 373.095px",
        }}
      />
      <path
        d="M185.77,374.26v-2.35a.22.22,0,0,1,.22-.22.22.22,0,0,1,.22.22v1.38l.82-.82a.22.22,0,0,1,.31.31l-.6.6.62.74a.22.22,0,0,1,0,.31.19.19,0,0,1-.14.05.18.18,0,0,1-.16-.08l-.59-.71-.22.22v.35a.22.22,0,0,1-.22.22A.22.22,0,0,1,185.77,374.26Z"
        id="elhyezxjizm27"
        className="animable"
        style={{
          transformOrigin: "186.597px 373.087px",
        }}
      />
      <path
        d="M187.77,373.48a1,1,0,0,1,1-1,1,1,0,0,1,1,.93v.06a.2.2,0,0,1-.21.16h-1.27a.55.55,0,0,0,.14.26.57.57,0,0,0,.38.18.66.66,0,0,0,.42-.1.23.23,0,0,1,.3,0,.19.19,0,0,1,0,.26,1,1,0,0,1-.72.26A1,1,0,0,1,187.77,373.48Zm.43-.19h1.13a.66.66,0,0,0-.59-.43A.56.56,0,0,0,188.2,373.29Z"
        id="elfgjaluuijhj"
        className="animable"
        style={{
          transformOrigin: "188.77px 373.486px",
        }}
      />
      <path
        d="M190.25,373.91a.21.21,0,0,1,.3,0,.73.73,0,0,0,.44.18.57.57,0,0,0,.27-.08.19.19,0,0,0,.07-.12s0,0,0,0l0-.05a1.06,1.06,0,0,0-.32-.11h0a2,2,0,0,1-.35-.1.77.77,0,0,1-.27-.24.43.43,0,0,1-.07-.25.55.55,0,0,1,.24-.44.89.89,0,0,1,.49-.15,1,1,0,0,1,.6.23.22.22,0,0,1,.06.29.22.22,0,0,1-.3.06.6.6,0,0,0-.36-.15.4.4,0,0,0-.24.07c-.05,0-.07.07-.07.09s0,0,0,0a.11.11,0,0,0,0,0,.64.64,0,0,0,.29.1h0a1.6,1.6,0,0,1,.37.12.59.59,0,0,1,.28.24.5.5,0,0,1,.08.26.57.57,0,0,1-.25.46.94.94,0,0,1-.52.16,1.13,1.13,0,0,1-.72-.27A.22.22,0,0,1,190.25,373.91Z"
        id="elp20l10d58pj"
        className="animable"
        style={{
          transformOrigin: "190.98px 373.515px",
        }}
      />
      <rect
        x={159.05}
        y={163.42}
        width={181.9}
        height={181.9}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "250px 254.37px",
        }}
        id="el2uhrkrtrwme"
        className="animable"
      />
      <path
        d="M176.16,364.34h-.56c-.15-.1-3.74-2.55-5.28-5.39a5.91,5.91,0,0,1-.37-5.65,2.81,2.81,0,0,1,2.49-1.43,3.9,3.9,0,0,1,3.44,2.43,3.93,3.93,0,0,1,3.44-2.43,2.83,2.83,0,0,1,2.5,1.43,5.94,5.94,0,0,1-.36,5.65h0C179.9,361.79,176.31,364.24,176.16,364.34Zm-3.72-11.47a1.81,1.81,0,0,0-1.63.94,5,5,0,0,0,.38,4.66,17.46,17.46,0,0,0,4.69,4.84,17.47,17.47,0,0,0,4.7-4.84h0a5,5,0,0,0,.38-4.65,1.81,1.81,0,0,0-1.64-.95c-2.28,0-2.92,2.89-2.95,3h-1C175.37,355.76,174.73,352.87,172.44,352.87Zm8.58,5.84h0Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "175.885px 358.105px",
        }}
        id="elnf15vum6wkc"
        className="animable"
      />
      <path
        d="M218.61,365.05l-.89-.17-1.8-6.73-4.17-4.55.36-.84h14.72l.4.8Zm-5.36-11.29,3.49,3.81.11.2,1.57,5.86,7.41-9.87Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "219.49px 358.905px",
        }}
        id="el9i4royctiak"
        className="animable"
      />
      <g id="elu7bdln7i62f">
        <rect
          x={215.38}
          y={355.08}
          width={12.44}
          height={1}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "221.6px 355.58px",
            transform: "rotate(-23.93deg)",
          }}
          className="animable"
          id="elwky6lqytxy"
        />
      </g>
      <path
        d="M196.39,364.42a6.28,6.28,0,1,1,6.28-6.27,6.46,6.46,0,0,1-.26,1.79l.94,3.86-.6.61-3.3-.78A6.31,6.31,0,0,1,196.39,364.42Zm0-11.55a5.28,5.28,0,1,0,2.72,9.8l.37-.06,2.71.64L201.4,360v-.27a5.27,5.27,0,0,0-5-6.9Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "196.73px 358.14px",
        }}
        id="elizzim7i1ge"
        className="animable"
      />
      <path
        d="M319.13,364.33l-.79-.41V353.26l.5-.5h8.66l.5.5v10.66l-.79.41-4-3.67Zm.21-10.57v9.18l3.54-3.3h.58l3.54,3.3v-9.18Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "323.17px 358.545px",
        }}
        id="elt9mvfhn4xkq"
        className="animable"
      />
      <rect
        x={159.05}
        y={133.08}
        width={181.37}
        height={0.25}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "249.735px 133.205px",
        }}
        id="eljdammolz5b"
        className="animable"
      />
      <path
        d="M220,259.64c-.85,1.55-3.07,1.92-4.73,2.38-2.44.69-4.88,1.39-7.33,2.07l-14.3,4c-2.41.68-4.81,1.43-7.24,2-1.72.42-4.88-1.31-4.63-1.21-1.12-3.59-.75-7.75,2.39-10.44.27-.23,1-.55,1.14-.82.34-.58-.16-1.45-.37-2a37,37,0,0,0-1.55-3.55,13.73,13.73,0,0,0-.85-1.61c-.47-.72-1.18-.64-2-.58a3.85,3.85,0,0,1-2.57-.5c-1.45-1.07-.43-2.38.54-3.36a17.57,17.57,0,0,1,4.56-3.3,17,17,0,0,1,11.25-1.42c4.11.92,7,3.55,9.58,6.46.72.82,1.21,1.56,2.45,1.75,1.07.18,2.14.27,3.21.46a19.51,19.51,0,0,1,6.07,2C218.08,253.48,221.57,256.74,220,259.64Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "198.814px 255.533px",
        }}
        id="elezqtsts2rfj"
        className="animable"
      />
      <path
        d="M218.75,263.39c-1.86,1.26-4.15,1.63-6.4,2a20,20,0,0,0-3.95,1,22.82,22.82,0,0,0-3.36,1.76,31.35,31.35,0,0,1-6.6,3,29.91,29.91,0,0,1-7.24,1.31c-2.28.13-4.92.17-7-.8a3.84,3.84,0,0,1-2.5-4,4,4,0,0,1,1.28-2.19c.73-.65,2.31-1.13,2.33-2.2,0-1.34-6-3.49-8.37-7.94-1-1.91-1.63-4.28-.58-6.29s3.38-3,5.69-3.37a25.44,25.44,0,0,1,7.44.32,35.13,35.13,0,0,1,7.46,2.09c2.35.95,4.55,2.16,6.86,3.18a29.23,29.23,0,0,0,7.56,2.14c3.77.55,9.24,1.61,9.73,5.83A4.57,4.57,0,0,1,218.75,263.39Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "198.46px 259.03px",
        }}
        id="elx9s6n8nh2gg"
        className="animable"
      />
      <path
        d="M184.89,266.14a1,1,0,0,0-.78.67.89.89,0,0,0-.06.54s0,0,0,0a.69.69,0,0,0,0,.2,1,1,0,0,0,1.89.24A1.1,1.1,0,0,0,184.89,266.14Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "185.061px 267.252px",
        }}
        id="elzn66jmamcqe"
        className="animable"
      />
      <path
        d="M214.38,262l0-.08h0a.58.58,0,0,0-.16-.57.67.67,0,0,0-.14-.09.52.52,0,0,0-.79.18c-.28.53.39,1.24.9.79a.52.52,0,0,0,.13-.17l0,0A0,0,0,0,1,214.38,262Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "213.812px 261.76px",
        }}
        id="el1in7hvydf9w"
        className="animable"
      />
      <path
        d="M180.92,248.21l0-.08h0a.57.57,0,0,0-.16-.56.48.48,0,0,0-.14-.09.52.52,0,0,0-.79.18c-.28.53.4,1.24.9.79a.62.62,0,0,0,.14-.18v0S180.92,248.22,180.92,248.21Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "180.352px 247.98px",
        }}
        id="elfkl8jsi8xst"
        className="animable"
      />
      <path
        d="M188.86,265.83a.42.42,0,0,0-.52.17.25.25,0,0,0,0,.22.4.4,0,0,0,.76.13A.4.4,0,0,0,188.86,265.83Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "188.72px 266.189px",
        }}
        id="eloqn4fpcsbh"
        className="animable"
      />
      <path
        d="M201,256.11a.42.42,0,0,0-.52.17.22.22,0,0,0,0,.22.4.4,0,0,0,.76.13A.4.4,0,0,0,201,256.11Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "200.858px 256.469px",
        }}
        id="elq2x6cbfnffh"
        className="animable"
      />
      <path
        d="M216.51,262a.43.43,0,0,0-.53.17.25.25,0,0,0,0,.22.4.4,0,0,0,.76.13A.4.4,0,0,0,216.51,262Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "216.361px 262.359px",
        }}
        id="el0zyikq13ok2i"
        className="animable"
      />
      <path
        d="M259,181.68c-.12,1.63-2.21,2.12-3.5,2.48-3.87,1.09-8,.68-11.89.15-4.23-.56-8.64-1.35-12.86-.37a12,12,0,0,0-7.9,5.31c25.23-3.09,32.31,15.89,30.7,16.61-1.8.82-7.34,3.28-9.3,3.48-4.31.44-8.68-.05-13-.22-4.53-.19-9.06-.29-13.59-.42a249.14,249.14,0,0,1-26.76-1.82,108.17,108.17,0,0,1-13.23-2.61c-3.14-.83-8.39-1.4-8.07-4.89.58-6.24,6.15-15.91,20.63-14.84a21.13,21.13,0,0,1,17.36-20.86,21.54,21.54,0,0,1,17.51,5,18.39,18.39,0,0,1,24.2,5.87,8.31,8.31,0,0,1,8.24,3.17A6.27,6.27,0,0,1,259,181.68Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "214.293px 186.465px",
        }}
        id="elg6ik8n8uqfg"
        className="animable"
      />
      <path
        d="M262.4,183.32c-1,2.6-3.6,4.2-6.09,5.16-6.3,2.44-13.21,1-19.71.41a37.75,37.75,0,0,0-9.79.09c-3,.5-6.9,1.71-8.64,4.38-1.22,1.87.25,3.84,2.15,4.38,1.75.5,3.66,0,5.42-.17a93.53,93.53,0,0,1,11.71-.82c5.81,0,13,.77,15.54,6.91a7.29,7.29,0,0,1-1,7.39,14.93,14.93,0,0,1-5.3,4.51,9.81,9.81,0,0,1-7.05,2.43c-4.61-.1-9-1.9-13.52-2.75a21.13,21.13,0,0,0-6.54-.35,46,46,0,0,0-6.1,1.59,21.47,21.47,0,0,1-11.84-.12c-3.85-1.16-7.31-3.28-11.18-4.41-3.6-1-7.31-1.71-10.86-2.92-3.17-1.09-6.59-2.69-8.67-5.42a5.79,5.79,0,0,1,.91-8.21,17.11,17.11,0,0,1,10.79-3.73c10.71,0,11.29-5.14,10.71-6.54a9.26,9.26,0,0,1,.13-8.06,11.65,11.65,0,0,1,5.84-5.08,16.25,16.25,0,0,1,9.24-.6c3.57.68,6.73,2.33,10.16,3.42,3.93,1.25,7.7,0,11.51-1a58.63,58.63,0,0,1,10.57-2.07,38.46,38.46,0,0,1,10.66.37c3.09.57,6.4,1.5,8.77,3.67C262.26,177.62,263.45,180.63,262.4,183.32Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "216.209px 194.495px",
        }}
        id="elz38mmgkixy"
        className="animable"
      />
      <path
        d="M174.68,197.53a1,1,0,0,0-.78.68.87.87,0,0,0-.06.54,0,0,0,0,0,0,0,.76.76,0,0,0,0,.21,1.05,1.05,0,0,0,1.9.23A1.11,1.11,0,0,0,174.68,197.53Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "174.855px 198.611px",
        }}
        id="elj8wcfisrvn"
        className="animable"
      />
      <path
        d="M240.15,210.66a1,1,0,0,0-.77.68.82.82,0,0,0-.07.54s0,0,0,0a.51.51,0,0,0,0,.2,1,1,0,0,0,1.89.24A1.12,1.12,0,0,0,240.15,210.66Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "240.316px 211.778px",
        }}
        id="elz08wuhz0ys"
        className="animable"
      />
      <path
        d="M178.37,200.61l0-.08h0a.58.58,0,0,0-.16-.57.57.57,0,0,0-.13-.08.53.53,0,0,0-.8.17c-.28.54.4,1.25.9.79a.75.75,0,0,0,.14-.17v0S178.37,200.62,178.37,200.61Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "177.802px 200.376px",
        }}
        id="elqkblfyc2jf"
        className="animable"
      />
      <path
        d="M252.75,177.43a.13.13,0,0,0,0-.08h0a.58.58,0,0,0-.16-.57.41.41,0,0,0-.13-.08.53.53,0,0,0-.8.17c-.28.54.4,1.25.9.8a.49.49,0,0,0,.14-.18v0A0,0,0,0,0,252.75,177.43Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "252.182px 177.199px",
        }}
        id="elyr8hi8utl5"
        className="animable"
      />
      <path
        d="M178.65,197.22a.43.43,0,0,0-.52.17.27.27,0,0,0,0,.23.4.4,0,1,0,.56-.4Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "178.516px 197.588px",
        }}
        id="el183nx158cb4"
        className="animable"
      />
      <path
        d="M216.38,177.44a.42.42,0,0,0-.52.17.25.25,0,0,0,0,.22.4.4,0,1,0,.56-.39Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "216.247px 177.807px",
        }}
        id="el5o131tolkw8"
        className="animable"
      />
      <path
        d="M256.6,176.43a.41.41,0,0,0-.52.16.24.24,0,0,0,0,.23.39.39,0,1,0,.55-.39Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "256.455px 176.784px",
        }}
        id="elmrxvpo39k7b"
        className="animable"
      />
      <path
        d="M205.07,231.19c-1.7,3.54-6.28,2.57-9.21,1.63-4.37-1.4-8.71-2.88-13.16-4a47.05,47.05,0,0,0-13.77-1.52c-1.7.1-3.93.78-5.46-.28a2.22,2.22,0,0,1-.82-2.91c-.27-3.25,2.55-5.66,5.59-6.66a2.78,2.78,0,0,0,1.72-1.19c.26-.41.46-.85.72-1.26a15,15,0,0,1,1.76-2.27,15.85,15.85,0,0,1,4.54-3.33,15.36,15.36,0,0,1,18.55,4.29c.59.74,1,1.59,1.61,2.35a8.7,8.7,0,0,0,2.47,2,13.12,13.12,0,0,1,3.61,3.55,13.3,13.3,0,0,1,2.06,4.89A7.83,7.83,0,0,1,205.07,231.19Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "183.975px 220.812px",
        }}
        id="elxjaq0tb7im"
        className="animable"
      />
      <path
        d="M204.09,233.39a7.85,7.85,0,0,1-5.17,3.15c-4.26.66-7.91-1.7-11.37-3.83a8.69,8.69,0,0,0-6.46-1.46,44.09,44.09,0,0,1-5.6.89c-3.6.14-7.85-.6-10.79-2.82-2.41-1.82-3.33-5.37-.61-7.37a12.27,12.27,0,0,1,5.07-1.78,24.08,24.08,0,0,0,6.13-1.9,22.88,22.88,0,0,1,21.87.53,20.44,20.44,0,0,1,7.5,7.36C205.91,228.44,206.17,231.63,204.09,233.39Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "184.028px 226.199px",
        }}
        id="eltbq3i9ijqme"
        className="animable"
      />
      <path
        d="M197.7,226.54a1,1,0,0,0-.77.68.82.82,0,0,0-.07.54s0,0,0,0a.79.79,0,0,0,0,.2,1,1,0,0,0,1.89.24A1.12,1.12,0,0,0,197.7,226.54Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "197.866px 227.658px",
        }}
        id="elclaj9ryjkva"
        className="animable"
      />
      <path
        d="M166.26,224a1,1,0,0,0-.78.68,1,1,0,0,0-.07.54,0,0,0,0,1,0,0,1.55,1.55,0,0,0,0,.21,1,1,0,0,0,1.89.23A1.1,1.1,0,0,0,166.26,224Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "166.427px 225.118px",
        }}
        id="elx121r85dmc"
        className="animable"
      />
      <path
        d="M201.4,229.63a.24.24,0,0,0,0-.08h0a.54.54,0,0,0-.16-.56.43.43,0,0,0-.13-.09.53.53,0,0,0-.8.17c-.28.54.4,1.25.91.8a.59.59,0,0,0,.13-.18v0Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "200.834px 229.399px",
        }}
        id="eli2gxg86fbh"
        className="animable"
      />
      <path
        d="M179.53,229.72a.19.19,0,0,0,0-.08h0a.59.59,0,0,0-.17-.57.41.41,0,0,0-.13-.08.53.53,0,0,0-.8.17c-.28.54.4,1.25.91.79a.7.7,0,0,0,.13-.17v0Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "178.956px 229.486px",
        }}
        id="elz3yxannks1"
        className="animable"
      />
      <path
        d="M201.68,226.24a.43.43,0,0,0-.53.17.25.25,0,0,0,0,.22.4.4,0,0,0,.76.13A.41.41,0,0,0,201.68,226.24Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "201.53px 226.599px",
        }}
        id="elwpw62o37pa"
        className="animable"
      />
      <path
        d="M182.31,218a.43.43,0,0,0-.53.17.25.25,0,0,0,0,.22.4.4,0,0,0,.76.13A.4.4,0,0,0,182.31,218Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "182.161px 218.358px",
        }}
        id="elgyp75re2li4"
        className="animable"
      />
      <path
        d="M167.69,228a.41.41,0,0,0-.52.17.25.25,0,0,0,0,.22.39.39,0,0,0,.76.12A.39.39,0,0,0,167.69,228Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "167.55px 228.371px",
        }}
        id="elc9t9kdtvg3q"
        className="animable"
      />
      <path
        d="M246.24,345H216.87s14.55-17,20.52-31.15a30.08,30.08,0,0,0,2.47-9c.33-4.47.79-9.42.69-14.43h0c-.21-10.32-2.83-20.86-13.93-27.69a37.31,37.31,0,0,0-3.57-1.93c-11.21-5.29-20,2.45-22.09,4.1-.47.39-1.19,1-2.08,1.59-2.94,2.1-7.75,4.82-11.87,3.2-1-.41,3,.23,5.88-1.23s8.94-7.2,12.68-8.66a21.28,21.28,0,0,1-20.16-9.94c.48.6,8.29,11.12,21.8,8.11,4.1-.91,10.94-1.54,15.5.1,0,0,1.46-9.94-17.6-18.88S184.92,220,185.39,219c.4-.84,2.48,4.31,5.77,8.41a19.64,19.64,0,0,0,2.19,2.35c2.89,2.59,8.11,5,13.43,7.69,6.46,3.3,13.05,7.07,15.75,12.28,0,0-.16-4.15,0-9.21h0c.06-1.61.14-3.32.27-5,.36-4.56-2.65-14.91-10.22-21h0a21.6,21.6,0,0,0-16.4-4.61c-2.56.28-1-1.45,3.64-1.82a23.73,23.73,0,0,1,9.58,1.74,19.2,19.2,0,0,1-1.9-2.65h0a17.85,17.85,0,0,1-2.65-7.65,18,18,0,0,0-2-6.77c-.9-1.81-1.73-3-1.54-3.45.37-.9,3.28,1.1,4.56,7.12a86.42,86.42,0,0,1,3.1-8.48c1.1-2.1-1-6.93,0-7.12s3,4,0,11.86-.18,13.13,3.28,16.14,10.65,11.33,12.47,19.45c0,0,.52-5.1,1.4-14.89.64-7.17,5-12.95,6.1-12.49s-4.19,6.74-4.46,13.49c-.09,2.18,0,4.42.08,6.63.2,4.65.51,9.22-.39,13a30.84,30.84,0,0,0-.8,8,31.35,31.35,0,0,0,.57,5.19,22.77,22.77,0,0,0,4.64,10.51c2.58,3,8.13,7.12,12.27,13.9a34.51,34.51,0,0,1,5.06,17.29C249.7,306.91,241.68,337.55,246.24,345Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "217.263px 262.912px",
        }}
        id="elx6g6430tnee"
        className="animable"
      />
      <path
        d="M247.61,285.93c-.61-4.55-3.29-9.23-5.63-13.19-.06-.09-.2,0-.14.08,4.25,7.59,4.72,16.59,3.91,25.07-.89,9.29-4.22,18.32-4.84,27.64-.33,5,.72,10.19,2.11,15a.23.23,0,0,0,.45-.12c-2-9.44-.77-18.84.85-28.23C245.83,303.48,248.81,294.82,247.61,285.93Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "244.369px 306.701px",
        }}
        id="ele5umtyr4hy"
        className="animable"
      />
      <path
        d="M238.8,316.76a147,147,0,0,1-7.1,14.82c-1.3,2.5-2.53,5-3.67,7.6-.86,1.93-1.63,3.9-2.44,5.85h-3.33c1.81-5.29,5.29-9.84,8.43-14.42a80,80,0,0,0,5.23-8.66c1.61-3.14,2.81-6.41,4.13-9.67a.11.11,0,0,1,.21.06,37.44,37.44,0,0,1-1.48,4.41Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "231.261px 328.621px",
        }}
        id="el22xrn1p9f12"
        className="animable"
      />
      <path
        d="M240.21,320.34c-.48,1.89-1,3.76-1.53,5.62,0,.15-.07.3-.1.46a46.53,46.53,0,0,0-.82,6.55,44.17,44.17,0,0,0,.09,6.3,42.34,42.34,0,0,1,.44,5.76h-6c.3-4.21,2-8.2,3.51-12.11.77-2,1.5-3.92,2.15-5.92.18-.54.35-1.08.52-1.62.27-1.09.57-2.16.91-3.22a5.66,5.66,0,0,1,.51-1.49c.05-.12.09-.25.13-.38S240.24,320.22,240.21,320.34Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "236.252px 332.623px",
        }}
        id="elym7dxolp2fn"
        className="animable"
      />
      <path
        d="M243.5,293.21a.14.14,0,0,1-.27,0,50.55,50.55,0,0,0-1.4-10.11,44.4,44.4,0,0,0-3.51-9.21c-2.75-5.27-6.9-10.44-12-13.61,0,0,0,0,0,0a29,29,0,0,1,6.44,4.82,22.1,22.1,0,0,1,9,13.62c.34,1.63.61,3.32.8,5A42,42,0,0,1,243.5,293.21Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "234.912px 276.796px",
        }}
        id="elvxfc64zciz"
        className="animable"
      />
      <path
        d="M241.71,305.92c-.73,3.07-2.53,5.47-4.32,8a30.08,30.08,0,0,0,2.47-9c.33-4.47.79-9.42.69-14.43C241.66,295.6,242.94,300.72,241.71,305.92Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "239.801px 302.205px",
        }}
        id="el38oay5xfdjj"
        className="animable"
      />
      <path
        d="M244.1,271.57a49.34,49.34,0,0,0-3.58-3.65c-2.46-2.24-5.37-4-7.69-6.35a19.94,19.94,0,0,1-5.64-14.41,22.77,22.77,0,0,0,4.64,10.51C234.41,260.63,240,264.79,244.1,271.57Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "235.642px 259.365px",
        }}
        id="elke1a8mnbam"
        className="animable"
      />
      <path
        d="M206.78,237.46a37,37,0,0,1-7.31-2.31,21.37,21.37,0,0,1-5.93-4.82,21.92,21.92,0,0,1-2.38-2.91,19.64,19.64,0,0,0,2.19,2.35C196.24,232.36,201.46,234.75,206.78,237.46Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "198.97px 232.44px",
        }}
        id="elxsugsismcn"
        className="animable"
      />
      <path
        d="M222.8,235.51c.36-4.56-2.65-14.91-10.22-21a21.42,21.42,0,0,1,5.74,5,26,26,0,0,1,4.15,6.33c2,4.73.94,9.77.06,14.66C222.59,238.91,222.67,237.2,222.8,235.51Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "218.095px 227.505px",
        }}
        id="eldrbofifezku"
        className="animable"
      />
      <path
        d="M226.62,262.79a37.31,37.31,0,0,0-3.57-1.93c-11.21-5.29-20,2.45-22.09,4.1-.47.39-1.19,1-2.08,1.59a24.25,24.25,0,0,1,13.57-8.37,13.46,13.46,0,0,1,8.36.63A17,17,0,0,1,226.62,262.79Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "212.75px 262.17px",
        }}
        id="el0idzlcwv4sz"
        className="animable"
      />
      <path
        d="M218.74,246.53c-2.81-3.92-7.51-6.15-11.9-7.82,0,0-.05,0,0,.06,4.15,2.38,8.3,4.48,11.68,7.95C218.62,246.84,218.84,246.68,218.74,246.53Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "212.792px 242.736px",
        }}
        id="ellzn1rf0z8v"
        className="animable"
      />
      <path
        d="M230.45,260.91c-1.72-2.39-3.55-5-4.19-7.91-.71-3.19-.62-6.43-.9-9.66a.1.1,0,0,0-.2,0,39.49,39.49,0,0,0-.09,5.33,23.39,23.39,0,0,0,.46,4.72c.73,3.11,2.62,5.37,4.68,7.71C230.32,261.22,230.55,261.05,230.45,260.91Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "227.747px 252.19px",
        }}
        id="el7zemfuu38in"
        className="animable"
      />
      <path
        d="M227.42,234a30.84,30.84,0,0,0-.8,8l0-.05c-1.32-4.15-.8-8.78,0-13q.72-4,1.26-8C228,225.63,228.32,230.2,227.42,234Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "226.924px 231.475px",
        }}
        id="elcnbfcjgmtuw"
        className="animable"
      />
      <path
        d="M219.75,219a33.28,33.28,0,0,0-4.79-5.61,26.62,26.62,0,0,1-5.06-5.95c-.06-.11-.22,0-.17.1a24.14,24.14,0,0,0,4.41,6,77.19,77.19,0,0,1,5.39,5.62C219.63,219.29,219.83,219.13,219.75,219Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "214.744px 213.301px",
        }}
        id="els3ezqvmze9"
        className="animable"
      />
      <path
        d="M207.49,207.14a17.85,17.85,0,0,1-2.65-7.65,18,18,0,0,0-2-6.77,17.69,17.69,0,0,1,2.84,5.42,18.37,18.37,0,0,1,.49,4.18A14.2,14.2,0,0,0,207.49,207.14Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "205.165px 199.93px",
        }}
        id="elg97p7jeeolr"
        className="animable"
      />
      <path
        d="M321.82,254.62a4.24,4.24,0,0,1-2.32.11c-1-.07-2-.12-3-.14a115.71,115.71,0,0,0-12.48.58c-4.15.35-8.31.75-12.48.84a51.13,51.13,0,0,1-6.19-.14,3.31,3.31,0,0,1-2.94-1.69.16.16,0,0,1-.2-.17,6.12,6.12,0,0,1,1.64-4.15,6.68,6.68,0,0,1,1.77-1.4,5.31,5.31,0,0,1,1.07-.46,7.51,7.51,0,0,0,1.11-.24c.41-.26.66-1.42.91-1.89a15.36,15.36,0,0,1,1.44-2.31,15.69,15.69,0,0,1,3.52-3.43,13.1,13.1,0,0,1,15.94.48,11.34,11.34,0,0,1,1.69,1.77c.18.23.32.52.51.74s.4.26.82.25a11,11,0,0,1,4.89.94,9,9,0,0,1,5.31,7.1C322.91,252.48,322.93,254.05,321.82,254.62Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "302.536px 246.853px",
        }}
        id="elomna9ap8log"
        className="animable"
      />
      <path
        d="M319.94,257a8,8,0,0,1-5-.27c-1.15-.35-2.07-.89-3.25-.32-.82.39-1.65.76-2.5,1.08a36.78,36.78,0,0,1-10.61,2.42,34.59,34.59,0,0,1-10.92-.81c-2.42-.59-5.15-2.14-5.43-4.69a1.85,1.85,0,0,1-.07-.41c-.14-1.55,1.24-2.64,2.5-3.21a12.47,12.47,0,0,1,2.67-.81,15.23,15.23,0,0,1,1.53-.23c.4,0,1.25.07,1.58-.14s.46-.7.66-1,.44-.61.68-.9A11.29,11.29,0,0,1,293.6,246c5.64-4.1,12.84-2.46,18.55.53,1.79.94,3.51,2.43,5.56,2.6A6.28,6.28,0,0,1,321.9,251C323.93,253.13,322.46,256.13,319.94,257Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "302.502px 251.79px",
        }}
        id="elzujruxpp08"
        className="animable"
      />
      <path
        d="M285.62,251.83a.89.89,0,0,0-.67.58.74.74,0,0,0-.05.47,0,0,0,0,0,0,0,.47.47,0,0,0,0,.17.89.89,0,0,0,1.62.21A1,1,0,0,0,285.62,251.83Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "285.75px 252.762px",
        }}
        id="el089zynll7chm"
        className="animable"
      />
      <path
        d="M304.88,253.61a.89.89,0,0,0-.67.58.74.74,0,0,0,0,.47,0,0,0,0,0,0,0,.51.51,0,0,0,0,.17.9.9,0,0,0,1.62.21A1,1,0,0,0,304.88,253.61Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "305.05px 254.535px",
        }}
        id="elppbam4tf2y9"
        className="animable"
      />
      <path
        d="M321.23,254.48a.14.14,0,0,0,0-.06h0a.5.5,0,0,0-.13-.49.47.47,0,0,0-.12-.07.45.45,0,0,0-.68.15c-.24.46.34,1.07.77.68a.44.44,0,0,0,.12-.15v0S321.23,254.49,321.23,254.48Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "320.746px 254.289px",
        }}
        id="eltusk4sv2efa"
        className="animable"
      />
      <path
        d="M300.21,245.3a.14.14,0,0,0,0-.06h0a.5.5,0,0,0-.13-.49l-.12-.07a.45.45,0,0,0-.68.15c-.24.46.34,1.07.77.68a.44.44,0,0,0,.12-.15v0A0,0,0,0,1,300.21,245.3Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "299.726px 245.109px",
        }}
        id="ellpda561kdch"
        className="animable"
      />
      <path
        d="M289.51,251.85a.36.36,0,0,0-.45.14.21.21,0,0,0,0,.2.34.34,0,1,0,.48-.34Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "289.387px 252.16px",
        }}
        id="el6pm1g4b9nip"
        className="animable"
      />
      <path
        d="M319,255.18a.35.35,0,0,0-.45.15.19.19,0,0,0,0,.19.34.34,0,0,0,.65.11A.35.35,0,0,0,319,255.18Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "318.874px 255.491px",
        }}
        id="el9frruh6cii"
        className="animable"
      />
      <path
        d="M334.66,214.06c-3,1.35-6.63,1.34-9.88,1.58-14.66,1.08-29.37,1.18-44,2-7.35.44-14.69,1.06-22,2.1-3.43.48-7,1.47-10.52.85a7.54,7.54,0,0,1-5.77-4.14l-.1.34c0,.08-.15.06-.13,0s.09-.36.14-.54v0a.21.21,0,0,1,.08-.27,57.55,57.55,0,0,1,2.57-8.25c1.81-4.34,4.71-8.47,9-10.61s9.27-1.91,13.81-.83a35.79,35.79,0,0,1,1.19-4.07c2.08-5.78,5.83-11.11,11.34-14a18.53,18.53,0,0,1,8.47-2.28c13.44-.11,18.22,10.1,18.73,11.41.44,1.13,1.75.56,2.63.41s1.62-.22,2.43-.28a25.64,25.64,0,0,1,23.63,12.28c1.46,2.4,3,5.38,2.94,8.25S337.12,213,334.66,214.06Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "290.74px 198.364px",
        }}
        id="elbdvzzrdpv4j"
        className="animable"
      />
      <path
        d="M340,209.35c-.65,4.53-3.63,9.16-7.91,11a21.43,21.43,0,0,1-6.86,1.43,72.51,72.51,0,0,1-8.34.15,73.92,73.92,0,0,1-8.4-.81c-2.77-.44-5.48-1.24-8.26-1.59s-5.63.39-8.38,1.11a28.12,28.12,0,0,0-7,2.6,1.58,1.58,0,0,0,1.65.07.24.24,0,0,1,.36.16c3.55-1.22,7.67-1.81,10.56.87a7.52,7.52,0,0,1,1,9.53c-2.09,2.95-6,3.45-9.33,3.15a26.37,26.37,0,0,1-3.17-.48,11.34,11.34,0,0,0-3.21-.52c-1.13.11-2,.94-3.05,1.28a4.77,4.77,0,0,1-2.7,0c-2.09-.55-3.64-2.06-5.35-3.29a8,8,0,0,0-3.57-1.54,15.52,15.52,0,0,0-3.85.17,17.13,17.13,0,0,1-6.84-.28,26.9,26.9,0,0,1-6.69-3.09c-3.41-2-7.41-4.36-8.29-8.58a13.67,13.67,0,0,1,.48-6.44,16.1,16.1,0,0,1,2.8-5.67,15.2,15.2,0,0,1,10.09-5.17c4.67-.5,9.33.94,13.4,3.15a5.82,5.82,0,0,1,.85-2.38c2.48-4,7.51-4.35,11.71-3.72.71.11,1.42.28,2.13.37s.88-.27,1.34-.65a28.82,28.82,0,0,1,8.35-4.65,31,31,0,0,1,12.53-1.75,28.69,28.69,0,0,1,6.36,1.14c2.27.68,4.33,1.84,6.56,2.64a8.67,8.67,0,0,0,4.43.38,27.22,27.22,0,0,1,3.83-.44,14.77,14.77,0,0,1,7.3,1.63A10.09,10.09,0,0,1,340,209.35Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "291.13px 215.603px",
        }}
        id="elowlsx5x7z09"
        className="animable"
      />
      <path
        d="M331.87,210.74a.85.85,0,0,0,.66-.58.71.71,0,0,0,.06-.46s0,0,0,0a.57.57,0,0,0,0-.18.9.9,0,0,0-1.62-.2A1,1,0,0,0,331.87,210.74Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "331.741px 209.818px",
        }}
        id="ell999ah1aug"
        className="animable"
      />
      <path
        d="M256.3,212.92a.89.89,0,0,0,.67-.58.74.74,0,0,0,0-.47v0l0-.17a.9.9,0,0,0-1.63-.21A1,1,0,0,0,256.3,212.92Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "256.125px 211.99px",
        }}
        id="elsf4vqb6zc79"
        className="animable"
      />
      <path
        d="M301.65,217.5a.87.87,0,0,0,.67-.58.81.81,0,0,0,.06-.47,0,0,0,0,1,0,0,.86.86,0,0,0,0-.17.91.91,0,0,0-1.63-.21A1,1,0,0,0,301.65,217.5Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "301.522px 216.576px",
        }}
        id="elb7mf01l9loo"
        className="animable"
      />
      <path
        d="M328.7,208.09l0,.07h0a.49.49,0,0,0,.14.48l.11.08a.46.46,0,0,0,.69-.15c.24-.46-.34-1.07-.78-.69a.57.57,0,0,0-.11.16v0S328.7,208.08,328.7,208.09Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "329.19px 208.289px",
        }}
        id="el5xf8i53pwwp"
        className="animable"
      />
      <path
        d="M264.79,228a.25.25,0,0,0,0,.07h0a.49.49,0,0,0,.14.48l.11.08a.46.46,0,0,0,.69-.15c.24-.46-.34-1.07-.78-.69a.42.42,0,0,0-.11.16l0,0Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "265.28px 228.199px",
        }}
        id="elpa5d5oz6l2"
        className="animable"
      />
      <path
        d="M328.45,211a.36.36,0,0,0,.45-.14.19.19,0,0,0,0-.19.34.34,0,0,0-.65-.11A.33.33,0,0,0,328.45,211Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "328.575px 210.694px",
        }}
        id="eldj0mhd0dz29"
        className="animable"
      />
      <path
        d="M296,228a.36.36,0,0,0,.45-.14.19.19,0,0,0,0-.19.34.34,0,0,0-.65-.11A.33.33,0,0,0,296,228Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "296.125px 227.694px",
        }}
        id="elmsh1ljge7k"
        className="animable"
      />
      <path
        d="M292.4,199.38a.35.35,0,0,0,.45-.15.19.19,0,0,0,0-.19.34.34,0,0,0-.65-.11A.35.35,0,0,0,292.4,199.38Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "292.526px 199.069px",
        }}
        id="elaozl9cta3pe"
        className="animable"
      />
      <path
        d="M261.49,228.87a.37.37,0,0,0,.45-.14.26.26,0,0,0,0-.19.34.34,0,0,0-.66-.11A.34.34,0,0,0,261.49,228.87Z"
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "261.608px 228.551px",
        }}
        id="elyn8fxqfx17e"
        className="animable"
      />
      <path
        d="M321.23,213c-.86,2.46-4.81,11.75-17.41,12.82-6.08.52-12.37,1.65-17.81,4.07-5.81,2.57-10.65,6.61-13.24,12.89-1.59,3.85-2.24,8.58-2.51,13.64h0c-.1,1.86-.15,3.75-.18,5.67a43.49,43.49,0,0,1,18-8.27,18.31,18.31,0,0,0,11.63-6.72c1-.86,2.56-1.07,2.67,0s-4.14,6.5-12.1,9.23h0a27.43,27.43,0,0,1-2.78.79c-7.12,1.63-14,7.42-17.47,10.79v1.56a92.17,92.17,0,0,1-.94,15.13,29.81,29.81,0,0,1-.88,3.75c-.37,1.19-.75,2.39-1.15,3.59-3.82,11.39-8.92,23-8.77,31.15.08,4.59,1.52,8.29,3,11.83,1.43,3.37,2.91,6.6,3.32,10.32H236.91s8.75-2.35,9.82-7.48-2.14-13,1.49-23.48a147,147,0,0,1,6.34-14h0c3.32-6.92,6.52-14.34,6.89-22,.33-6.68-.65-14.55-.06-22.52a41.14,41.14,0,0,1,3.3-14,31,31,0,0,0-.16-4.13,30.4,30.4,0,0,0-5.07-14.14,7.3,7.3,0,0,0-.92-1.11c-1.39-1.28-2.56-4.67.32-2.32,5.34,4.35,7.52,12.71,8.32,17.14a34,34,0,0,1,3.24-4.17c12.81-14.08,26-18.68,27.86-27.21s1.81-9.82,2.45-10.14,1.28,7.14-.85,11.84c.2-.18,6.86-6.32,14.2-5.44,1.57.19-2.17,1-6.58,3-3.06,1.41-6.44,3.43-8.58,6.27a54.89,54.89,0,0,1-9.27,9c-4.06,3.28-8,6.1-9.73,8.13a45,45,0,0,1,8.55-3.44h0a52,52,0,0,1,8.52-1.79c7.21-.87,14.63-.65,19.62-6.86h0a21.86,21.86,0,0,0,3.53-6.79C320.8,207.53,322.08,210.52,321.23,213Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "279.211px 270.455px",
        }}
        id="eluswv06zwvsr"
        className="animable"
      />
      <path
        d="M249.56,331.83c-.47-4.49-1.4-8.83-.79-13.35,0-.13-.19-.15-.22,0-1,4-.27,8.32.21,12.34a37.78,37.78,0,0,1,.31,6.2c-.1,2.09-.37,4.77-1.9,6.35a.08.08,0,0,0,.12.11,8.38,8.38,0,0,0,2.29-5.22A25.86,25.86,0,0,0,249.56,331.83Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "248.46px 330.94px",
        }}
        id="eljjrog5qfzoe"
        className="animable"
      />
      <path
        d="M258.38,345.22h-4.9a29.15,29.15,0,0,0-.48-8c-.59-2.71-1.39-5.35-1.8-8.11a42.38,42.38,0,0,1-.42-7.8c.2-5.05,1.26-10.52,3.76-15a.16.16,0,0,1,.28,0,.15.15,0,0,1,0,.15,44.44,44.44,0,0,0-2.2,9.45,40.27,40.27,0,0,0-.09,8.36,27.69,27.69,0,0,0,2.29,8.43C256.55,336.7,258.71,340.89,258.38,345.22Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "254.581px 325.724px",
        }}
        id="eltkkaekd1zg"
        className="animable"
      />
      <path
        d="M258.31,323.07c.08,4.59,1.52,8.29,3,11.83a28.13,28.13,0,0,1-4.67-9.43c-1.68-7.17,1.48-14.47,4.28-20.93,1.86-4.28,3.89-8.51,6.14-12.62C263.26,303.31,258.16,315,258.31,323.07Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "261.615px 313.41px",
        }}
        id="eld7tnbtp4kv6"
        className="animable"
      />
      <path
        d="M262.82,284.06a55.12,55.12,0,0,1-4.49,9.4c-1.25,2.26-2.49,4.52-3.77,6.77,3.32-6.92,6.52-14.34,6.89-22,.33-6.68-.65-14.55-.06-22.52.28,2.44.71,4.86,1.14,7.29C263.77,269.88,265,277.19,262.82,284.06Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "259.288px 277.97px",
        }}
        id="elq9df4b318be"
        className="animable"
      />
      <path
        d="M265.67,289.08a29.5,29.5,0,0,1-5.3,7.15A22.5,22.5,0,0,0,258,301s-.08,0-.07,0c1.22-4.77,4.71-8.44,6.64-12.89a27,27,0,0,0,1.57-15.72c0-.19.27-.28.3-.08C267.81,282.22,266.89,286.55,265.67,289.08Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "262.526px 286.599px",
        }}
        id="eluk3w3vmrzbt"
        className="animable"
      />
      <path
        d="M296.85,250.78a20.87,20.87,0,0,1-5.18,3.13,55.71,55.71,0,0,1-6.46,1.92.06.06,0,1,0,0,.11,29,29,0,0,0,7.12-1.63,10.8,10.8,0,0,0,4.73-3.29C297.19,250.88,297,250.67,296.85,250.78Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "291.115px 253.347px",
        }}
        id="elni096pmhgj"
        className="animable"
      />
      <path
        d="M290.3,256.31a27.43,27.43,0,0,1-2.78.79c-7.12,1.63-14,7.42-17.47,10.79v.32a.23.23,0,0,1-.07-.2.12.12,0,0,1,0-.1c2.72-3.79,5.91-7.64,10.3-9.52a33.1,33.1,0,0,1,8.18-1.83C289.08,256.47,289.69,256.38,290.3,256.31Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "280.135px 262.26px",
        }}
        id="elkhg8c94dcfq"
        className="animable"
      />
      <path
        d="M286,229.86c-5.81,2.57-10.65,6.61-13.24,12.89-1.59,3.85-2.24,8.58-2.51,13.64a29.52,29.52,0,0,1-.31-8.85,20.68,20.68,0,0,1,6.35-12.83,20.21,20.21,0,0,1,6.47-3.73C283.82,230.59,284.9,230.19,286,229.86Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "277.872px 243.125px",
        }}
        id="elbjq0yaowfxs"
        className="animable"
      />
      <path
        d="M267.93,269.22c0,.1-.15.12-.17,0-.87-4.48-2.26-8.85-2.71-13.42a23.51,23.51,0,0,1,2-12.73c.06-.12.26,0,.22.09-.3.86-.58,1.71-.83,2.57a24.39,24.39,0,0,0-.21,4.1c.08,1.69.33,3.36.56,5a36.75,36.75,0,0,1,.33,9.6c0-.11,0-.22-.07-.34,0,.12,0,.23,0,.35s.07.05.08,0h0C267.45,266.05,267.73,267.63,267.93,269.22Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "266.403px 256.161px",
        }}
        id="el2j8sxsecl6v"
        className="animable"
      />
      <path
        d="M267.15,264.48h0c0,.05-.09.06-.08,0s0-.23,0-.35C267.1,264.26,267.13,264.37,267.15,264.48Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "267.11px 264.326px",
        }}
        id="elbee4w9445cs"
        className="animable"
      />
      <path
        d="M264.53,237.53a30.4,30.4,0,0,0-5.07-14.14,18,18,0,0,1,4.48,7.71A18.55,18.55,0,0,1,264.53,237.53Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "262.027px 230.46px",
        }}
        id="elqhc2x0liuq8"
        className="animable"
      />
      <path
        d="M283.24,229.25c-5.27,1.44-10.89,4.13-12.68,9.68a.05.05,0,1,0,.1,0,13.57,13.57,0,0,1,5.23-5.8,60.68,60.68,0,0,1,7.46-3.67C283.49,229.43,283.39,229.21,283.24,229.25Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "276.989px 234.113px",
        }}
        id="elpfu9zb8htc"
        className="animable"
      />
      <path
        d="M288.91,217.85c-2.06,1.72-3.86,3.69-6,5.28-1.83,1.34-3.77,2.39-5.11,4.27-.09.12.11.28.21.16,1.58-1.84,3.94-2.84,5.84-4.32a31.68,31.68,0,0,0,5.26-5.22C289.17,217.9,289,217.74,288.91,217.85Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "283.45px 222.708px",
        }}
        id="eli5ns6job7u"
        className="animable"
      />
      <path
        d="M316.62,216.25c-.37.55-.78,1.1-1.19,1.63a13.55,13.55,0,0,1-2.43,2.64,14.12,14.12,0,0,1-3,1.63,27.45,27.45,0,0,1-7.23,1.95c-4.75.61-9.53.26-14.28.8a52,52,0,0,1,8.52-1.79C304.21,222.24,311.63,222.46,316.62,216.25Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "302.555px 220.575px",
        }}
        id="elyinqdpdq8dn"
        className="animable"
      />
      <path
        d="M307.5,205c-3.06,1.41-6.44,3.43-8.58,6.27a54.89,54.89,0,0,1-9.27,9C294.77,214.64,299.62,206.48,307.5,205Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "298.575px 212.635px",
        }}
        id="eliji53pgcrza"
        className="animable"
      />
    </g>
    <g
      id="freepik--paper-plane--inject-69"
      className="animable"
      style={{
        transformOrigin: "277.705px 310.045px",
      }}
    >
      <path
        d="M133.83,346.93c-.05-.68-.07-1.36-.07-2h.75c0,.64,0,1.3.06,2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "134.165px 345.93px",
        }}
        id="elhfy03c2gx78"
        className="animable"
      />
      <path
        d="M211.3,405h-.13v-.75h.14c1.27,0,2.56,0,3.85-.09l0,.75C213.9,405,212.59,405,211.3,405Zm-5.15-.16c-1.34-.08-2.69-.2-4-.35l.08-.75c1.31.15,2.65.27,4,.35Zm14.06-.32-.08-.75c1.31-.14,2.64-.31,4-.51l.12.74C222.87,404.22,221.53,404.4,220.21,404.54Zm-23.05-.74c-1.3-.22-2.63-.49-3.95-.78l.17-.73c1.3.29,2.62.55,3.91.77Zm32-.71-.16-.73c1.3-.28,2.6-.59,3.88-.93l.19.72C231.76,402.5,230.45,402.81,229.14,403.09Zm-40.8-1.32c-1.28-.36-2.57-.77-3.84-1.2l.24-.71c1.26.43,2.54.83,3.81,1.19Zm49.53-1-.23-.71c1.24-.4,2.51-.85,3.77-1.31l.26.7C240.4,399.88,239.12,400.33,237.87,400.73Zm-58.08-1.91c-1.23-.5-2.48-1-3.69-1.6l.31-.68c1.21.55,2.44,1.09,3.66,1.58Zm66.54-1.29-.3-.69c1.22-.53,2.43-1.1,3.6-1.69l.34.67C248.78,396.42,247.56,397,246.33,397.53ZM171.59,395c-1.18-.63-2.36-1.3-3.5-2l.38-.65c1.13.67,2.3,1.33,3.48,2Zm82.77-1.59-.39-.65c1.14-.68,2.26-1.4,3.36-2.15l.42.62C256.65,392,255.5,392.7,254.36,393.39Zm-90.52-3.07c-1.12-.75-2.22-1.54-3.29-2.33l.45-.6c1.06.79,2.15,1.56,3.26,2.31Zm98-2.09-.46-.59c1-.82,2.06-1.68,3.05-2.55l.5.56C263.88,386.53,262.84,387.4,261.79,388.23Zm-105.18-3.36c-1-.86-2.05-1.76-3-2.66l.51-.55c1,.89,2,1.78,3,2.64Zm111.94-2.65-.53-.53c.92-.91,1.85-1.88,2.77-2.87l.55.51C270.42,380.33,269.48,381.3,268.55,382.22ZM150,378.68c-.92-1-1.83-2-2.7-3l.57-.48c.86,1,1.76,2,2.68,3Zm124.64-3.13-.57-.48c.84-1,1.68-2.06,2.49-3.12l.6.46C276.33,373.48,275.49,374.53,274.64,375.55Zm-130.48-3.78c-.81-1.09-1.59-2.2-2.31-3.31l.62-.41c.72,1.1,1.49,2.2,2.29,3.27Zm136-3.39-.61-.43c.76-1.08,1.52-2.18,2.27-3.29l.62.42Q281.31,366.76,280.15,368.38Zm-140.89-4.24c-.65-1.2-1.26-2.41-1.8-3.61l.69-.31c.53,1.18,1.12,2.38,1.77,3.56Zm145.9-3.27-.64-.4c.71-1.13,1.4-2.26,2.09-3.41l.65.38C286.57,358.6,285.87,359.74,285.16,360.87Zm-149.53-5a39.89,39.89,0,0,1-1.07-3.9l.73-.16c.28,1.25.63,2.54,1.05,3.82Zm154.16-2.72-.65-.37c.65-1.15,1.31-2.32,1.95-3.49l.66.36C291.1,350.79,290.45,352,289.79,353.11Zm4.35-7.91-.67-.35c.63-1.17,1.25-2.36,1.87-3.54l.66.34C295.38,342.84,294.76,344,294.14,345.2Zm4.16-8-.67-.34c.6-1.18,1.21-2.37,1.81-3.57l.67.34Zm4.05-8.05-.67-.34,1.79-3.58.68.33Zm4-8.07-.67-.33c.59-1.19,1.2-2.39,1.8-3.58l.67.34Q307.27,319.28,306.39,321.07Zm4.08-8-.67-.35,1.84-3.56.67.35C311.69,310.67,311.07,311.85,310.47,313Zm4.18-8-.66-.36c.63-1.17,1.27-2.34,1.91-3.51l.66.36C315.92,302.72,315.28,303.89,314.65,305.06ZM319,297.2l-.65-.37c.66-1.15,1.32-2.31,2-3.46l.65.38C320.32,294.9,319.66,296.05,319,297.2Zm4.57-7.72-.64-.39q1.05-1.71,2.13-3.39l.63.4C325,287.22,324.27,288.35,323.57,289.48Zm4.85-7.55-.62-.41c.74-1.11,1.5-2.22,2.27-3.31l.61.43C329.92,279.73,329.16,280.83,328.42,281.93Zm5.19-7.34-.6-.45c.79-1.07,1.61-2.14,2.43-3.19l.59.46C335.21,272.46,334.4,273.52,333.61,274.59Zm5.55-7.07-.57-.48c.85-1,1.72-2,2.6-3.05l.57.5C340.88,265.49,340,266.5,339.16,267.52Zm5.95-6.73-.55-.51c.92-1,1.85-1.94,2.79-2.89l.53.53C346.94,258.87,346,259.82,345.11,260.79Zm6.36-6.34-.51-.55q1.46-1.36,3-2.7l.5.57C353.42,252.65,352.44,253.54,351.47,254.45Zm6.76-5.9-.47-.59c1-.84,2.11-1.68,3.16-2.48l.45.6C360.33,246.87,359.27,247.7,358.23,248.55Zm7.17-5.41-.43-.62c1.08-.76,2.2-1.52,3.32-2.25l.41.63C367.59,241.63,366.48,242.38,365.4,243.14Zm7.53-4.89-.39-.64c1.15-.69,2.32-1.36,3.48-2l.37.66C375.23,236.9,374.07,237.57,372.93,238.25Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "255.48px 320.305px",
        }}
        id="el8wni22u0qxm"
        className="animable"
      />
      <path
        d="M381,233.81l-.33-.67,1.79-.89.33.68Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "381.73px 233.03px",
        }}
        id="ela1ey3e15g0g"
        className="animable"
      />
      <polygon
        points="371.65 226.89 366.17 241.94 377.67 232.95 421.65 217 371.65 226.89"
        style={{
          fill: "#213E60",
          transformOrigin: "393.91px 229.47px",
        }}
        id="elff5ub4phr4"
        className="animable"
      />
      <g id="elplbhg4y74f">
        <polygon
          points="371.65 226.89 366.17 241.94 377.67 232.95 421.65 217 371.65 226.89"
          style={{
            fill: "rgb(23, 21, 62)",
            opacity: 0.1,
            transformOrigin: "393.91px 229.47px",
          }}
          className="animable"
          id="elmrvynibcydh"
        />
      </g>
      <polygon
        points="379.14 236.46 366.17 241.94 377.67 232.95 379.14 236.46"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "372.655px 237.445px",
        }}
        id="ele9gp3btkod4"
        className="animable"
      />
      <polygon
        points="377.67 232.95 421.65 217 385.57 252.21 377.67 232.95"
        style={{
          fill: "#213E60",
          transformOrigin: "399.66px 234.605px",
        }}
        id="elpjejsqd8tgb"
        className="animable"
      />
      <polygon
        points="371.65 226.89 353.37 215.09 421.65 217 371.65 226.89"
        style={{
          fill: "#213E60",
          transformOrigin: "387.51px 220.99px",
        }}
        id="elqpz0tvbwmx"
        className="animable"
      />
    </g>
    <g
      id="freepik--Character--inject-69"
      className="animable"
      style={{
        transformOrigin: "250.55px 240.829px",
      }}
    >
      <path
        d="M256,325.92c-.72,1.23-73.47,14.69-77.1,14.17a2.12,2.12,0,0,1-.51-.13c-4.59-1.42-27.1-17-28.81-18.31-4.22-3.27,7.36-32.06,11.62-37.15,2.83-3.38,8.68-5.37,8.68-5.37s10.15-51.28,19.18-63c2.26-2.93,47.52-10.25,56.15-7.68,3.69,1.1,13.34,8.55,13.78,10.07v0C259.49,220.78,256.68,324.68,256,325.92Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "203.859px 274.009px",
        }}
        id="elkjx1vnowsop"
        className="animable"
      />
      <path
        d="M256,325.92c-.72,1.23-73.47,14.69-77.1,14.17a2.12,2.12,0,0,1-.51-.13c4.38-19.94,25-113.53,25.84-114.23s44.27-6.48,54.76-7.17C259.49,220.78,256.68,324.68,256,325.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "218.72px 279.332px",
        }}
        id="el06teedwy5j96"
        className="animable"
      />
      <path
        d="M213.33,216.45c-.83-.59-2.7-10.47-1.63-12.64,1.2-2.43,18.76-3.75,20.05-2s3.17,11.62,2.69,12.05-3.33,1.18-3.81.6-1.6-8.81-2-9.2-12.67.51-13,1.2,1.85,8.85,1.41,9.28S214.14,217,213.33,216.45Z"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "222.947px 208.821px",
        }}
        id="el641slhjwre"
        className="animable"
      />
      <path
        d="M246.09,229.26c12.67,28.28,43.3,75.29,57,63.65,20.5-17.4,34.36-55.9,39.85-71.47,3.09-8.72-41.34-23.32-44.06-15.4-3.87,11.26-9.94,34.77-13.46,38.1-1.86,1.75-16.39-18.68-27.41-28.37C242.13,201.81,242,220.23,246.09,229.26Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "293.464px 249.245px",
        }}
        id="elk5k9az7fn4i"
        className="animable"
      />
      <path
        d="M354.06,208.33c-4,8.9-19.18,23.94-24.24,26.16s-31.78-22-31.22-27.59,16.5-35.44,25.33-40S358.16,199.11,354.06,208.33Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "326.548px 200.572px",
        }}
        id="elb6xjczh5r36"
        className="animable"
      />
      <path
        d="M300.69,200.64s.64-12.65-2.56-23.35c-2.68-9-7.68-22-2.9-23.67,9.82-3.34,22.28,29.22,22.28,29.22s3.19,15.25-6.24,19.41C305.35,204.87,300.69,200.64,300.69,200.64Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "305.636px 178.243px",
        }}
        id="el0ytz9r0oyzon"
        className="animable"
      />
      <path
        d="M311.76,176.64c.65,5.12,6.31,1.43,6.31,1.43s-6.87,7.28-4.17,12.3c2.63,4.84,9.31.13,9.8-.2-.36.39-6.5,7.25-3.26,12,3.37,4.95,9.27-.92,9.65-1.3-.23.47-3.1,6.78.19,9.85,5.65,5.25,13.43-10.68,19.42-12.46,0,0,4.18,9.8,4.36,10.06,0,0,7.71-15,4.86-23a5.38,5.38,0,0,0-5.7-3.61s3-4.57.58-8.4c-1.25-2-5.51-1.7-5.51-1.7s2.27-3.76-.11-7c-1.89-2.62-5.86-2-5.86-2s.5-4.61-2.3-6.66C334.39,151.87,310.39,165.68,311.76,176.64Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "335.628px 183.497px",
        }}
        id="elxnie89wixvm"
        className="animable"
      />
      <path
        d="M341.67,162.69c.08,0,.05-.16-.05-.13-9,2.61-18.09,8.24-23.88,15.68-.19.24.13.66.39.43C325.56,172.14,332.68,166.94,341.67,162.69Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "329.699px 170.646px",
        }}
        id="el3fssr14j6p9"
        className="animable"
      />
      <path
        d="M348.38,171.55c.1-.05,0-.21-.08-.18-9.26,2.75-19.33,9.37-25,18.73-.2.32-.05.8.2.45C327.75,184.61,340.27,175.33,348.38,171.55Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "335.815px 181.019px",
        }}
        id="el0hpla1za4ls5"
        className="animable"
      />
      <path
        d="M329.92,201.67c5.78-8.77,13.79-14.8,22.9-19.81.12-.07,0-.23-.1-.2-5.12,1.24-10.6,5-14.61,8.36a27.6,27.6,0,0,0-8.5,11.45C329.54,201.65,329.8,201.86,329.92,201.67Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "341.234px 191.701px",
        }}
        id="el1hil1frxood"
        className="animable"
      />
      <path
        d="M317.89,178.06c-.22.3.46.31.24.61-.92,1.26-5.8,9.34-3.56,11.85,1.79,2,5.74,1,7.11,0l3.43-2.48-2.36,3.52a17.37,17.37,0,0,0-2.37,5.09,6.15,6.15,0,0,0,.46,5,3.54,3.54,0,0,0,4.16,1.6,10.72,10.72,0,0,0,4.46-3l3.47-3.62-2.08,4.53a16.15,16.15,0,0,0-1.25,4,6.66,6.66,0,0,0,.3,3.86,3.16,3.16,0,0,0,2.76,1.9,7,7,0,0,0,3.66-1.47,55.84,55.84,0,0,0,6.47-5.8c1-1,2.11-2.06,3.21-3a10.4,10.4,0,0,1,3.7-2.38,11.35,11.35,0,0,0-3.42,2.67c-1,1.06-2,2.16-2.95,3.26a47.87,47.87,0,0,1-6.3,6.27,8.26,8.26,0,0,1-4.33,1.91,4.53,4.53,0,0,1-4.19-2.65A8.19,8.19,0,0,1,328,205a18.21,18.21,0,0,1,1.32-4.43l1.39.91a12.33,12.33,0,0,1-5.24,3.57,5.19,5.19,0,0,1-3.47-.13,5.76,5.76,0,0,1-2.59-2.25,7.77,7.77,0,0,1-.59-6.38,18.91,18.91,0,0,1,2.69-5.55l1.07,1c-1.77,1.2-6.06,2.82-9.24.05C309.74,187.55,316.55,179.46,317.89,178.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.001px 195.22px",
        }}
        id="ell187zfwf8ep"
        className="animable"
      />
      <path
        d="M318.07,178.07a10.15,10.15,0,0,1-3.08.72,2.38,2.38,0,0,1-2.21-1,4.89,4.89,0,0,1-.51-2.72c.06-1,.17-2.13.33-3.25a8.27,8.27,0,0,0-1.44,3.09,4.83,4.83,0,0,0,.41,3.68,3.52,3.52,0,0,0,1.62,1.26,3.71,3.71,0,0,0,1.95.07A5.62,5.62,0,0,0,318.07,178.07Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "314.519px 175.919px",
        }}
        id="elvyhjzwtbucm"
        className="animable"
      />
      <path
        d="M296.19,206.9l46.24,32.2s-27.62,57.23-44.69,57.07-41.73-43-50.27-61.54-3.42-34.23,13.78-17.33,23.36,23.83,23.92,23.6C286.25,240.46,296.19,206.9,296.19,206.9Z"
        style={{
          fill: "#213E60",
          transformOrigin: "292.923px 251.535px",
        }}
        id="elsm9bpfztit"
        className="animable"
      />
      <path
        d="M342.43,239.1S323.28,278.79,307,292c-3.26,2.65-6.41,4.23-9.27,4.2-17.07-.15-41.73-43-50.27-61.54-5.29-11.47-5.34-21.86-.53-24.09,3-1.38,7.76.32,14.31,6.76,17.3,17,23.36,23.83,23.92,23.6,1.08-.44,11-34,11-34Z"
        style={{
          fill: "#213E60",
          transformOrigin: "292.917px 251.565px",
        }}
        id="elmy6sdewbsms"
        className="animable"
      />
      <path
        d="M331.49,243.25c-1.22-1-2.45-2-3.69-3l-7.56-5.94c-5-3.93-10.15-7.7-15.32-11.42-2.94-2.12-5.82-4.34-8.84-6.33a.14.14,0,0,0-.17.22c2.4,2.12,5,4.06,7.47,6.07s5,4,7.5,6q7.55,5.87,15.26,11.5c1.44,1.06,2.85,2.18,4.34,3.17.76.51,1.48,1.07,2.25,1.57s1.58.94,2.34,1.47a.08.08,0,0,0,.1-.13C333.92,245.42,332.75,244.29,331.49,243.25Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "315.535px 231.559px",
        }}
        id="elq6e2306b2c"
        className="animable"
      />
      <path
        d="M285.56,239.86a117,117,0,0,0-4.34,14.59c-.6,2.45-1.08,4.92-1.55,7.39a58,58,0,0,0-1,7.42c0,.09.13.1.16,0,.76-2.38,1.32-4.86,1.88-7.3s1.16-4.89,1.71-7.35c1.11-4.91,2.4-9.78,3.36-14.72A.12.12,0,0,0,285.56,239.86Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "282.225px 254.566px",
        }}
        id="el8plsmuon2wh"
        className="animable"
      />
      <g id="eloc57pw3grv">
        <path
          d="M307,292c-3.26,2.65-6.41,4.23-9.27,4.2-17.07-.15-41.73-43-50.27-61.54-5.29-11.47-5.34-21.86-.53-24.09Z"
          style={{
            opacity: 0.1,
            transformOrigin: "275.202px 253.385px",
          }}
          className="animable"
          id="elrdiy9xh5e1p"
        />
      </g>
      <path
        d="M175.28,345.29l116,0c-.77-5.42-24-114-33.88-130.55-4.69-7.87-23.94-13.05-36.87-.56C195.83,238.07,174.34,344.22,175.28,345.29Z"
        style={{
          fill: "#213E60",
          transformOrigin: "233.265px 275.984px",
        }}
        id="ells5x8rghit"
        className="animable"
      />
      <path
        d="M276.87,277.57c-.3-1.49-.62-3-1-4.45-.67-2.91-1.4-5.8-2.17-8.69-1.09-4.06-2.26-8.12-3.48-12.16-.06-.64-.18-1.29-.27-1.93-.12-.87-.23-1.74-.37-2.61-.27-1.75-.56-3.5-.82-5.25a.08.08,0,1,0-.16,0,50.48,50.48,0,0,0,.41,5.36c0,.29.08.58.13.87-.15-.48-.29-1-.44-1.46-.51-1.6-1.08-3.18-1.61-4.77s-1-3.29-1.67-4.88a.07.07,0,0,0-.14.05c.32,1.48.78,2.92,1.17,4.38s.74,2.85,1.1,4.28c.74,2.89,1.59,5.76,2.36,8.64,1.55,5.76,3,11.56,4.62,17.3.44,1.57.88,3.14,1.34,4.71s.91,3.32,1.54,4.91c0,.08.17.07.16,0A41.15,41.15,0,0,0,276.87,277.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "271.423px 259.738px",
        }}
        id="elocum8kntmnn"
        className="animable"
      />
      <path
        d="M257.3,218.76a9.89,9.89,0,0,1-3.88,5.52c-2.1,1.3-4.74,1.28-7.09,1-5-.51-9.66-2.86-13.77-5.85-1.17-.86-2.3-1.78-3.42-2.71a33.08,33.08,0,0,1-3.14-2.9c-.07-.07-.17,0-.1.11.95,1,1.84,2.1,2.8,3.12a33.56,33.56,0,0,0,3,2.77,31,31,0,0,0,6.8,4.33,24.38,24.38,0,0,0,7.58,2.13c2.48.27,5.28.22,7.45-1.23a10.07,10.07,0,0,0,4-6.29A.07.07,0,1,0,257.3,218.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "241.703px 220.1px",
        }}
        id="elohfdxe7bgil"
        className="animable"
      />
      <path
        d="M249.48,220.33c-4.47,1.22-16.58-2.73-21-10.05-.3-.5.27-5.94.66-12.58.21-4,.36-8.53.2-12.64,0-.84,26,5.25,26,5.25s-2.19,8.72-1.87,15.88a9.69,9.69,0,0,0,.25,1.68c0,.08,0,.17,0,.28C254.46,211.33,254.91,218.86,249.48,220.33Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "241.868px 202.765px",
        }}
        id="elurpfc3dmr3"
        className="animable"
      />
      <path
        d="M253.77,207.87a1.86,1.86,0,0,0,0,.28,17.61,17.61,0,0,1-2.65.24c-14.35.25-19.7-17.29-21.12-23.39,4,.33,24.51,5.12,25.31,5.3h0s-2.19,8.71-1.87,15.88A9.84,9.84,0,0,0,253.77,207.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "242.655px 196.696px",
        }}
        id="elexfhsuqa9fc"
        className="animable"
      />
      <path
        d="M238.42,203.71s0,0,0,0"
        style={{
          fill: "none",
          stroke: "rgb(252, 171, 160)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0,
          transformOrigin: "238.42px 203.71px",
        }}
        id="elf00tjc7f74"
        className="animable"
      />
      <path
        d="M226,155.35c-2.85,9.13,1.84,35.58,8.31,41.5,9.38,8.6,24.82,9.5,32.14-1.8,7.09-11,.38-45.31-6.86-50.7C248.93,136.4,230.19,141.86,226,155.35Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "247.306px 172.039px",
        }}
        id="elw3zmpzhc7l"
        className="animable"
      />
      <path
        d="M252.53,171.54c0-.06-.13.11-.11.18.36,1.78.48,3.87-1,4.74,0,0,0,.11,0,.09C253.34,175.94,253.16,173.16,252.53,171.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "252.192px 174.04px",
        }}
        id="elwrtro1btse"
        className="animable"
      />
      <path
        d="M250.61,170c-2.9.28-2.14,6.07.56,5.81S253.05,169.72,250.61,170Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "250.806px 172.904px",
        }}
        id="elygc6fjj529"
        className="animable"
      />
      <path
        d="M262.1,170.23c0-.07.16.06.16.14.18,1.8.69,3.83,2.39,4.21.06,0,.06.11,0,.1C262.64,174.67,262,172,262.1,170.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "263.393px 172.445px",
        }}
        id="el16le9ze0qq3"
        className="animable"
      />
      <path
        d="M263.46,168.14c2.85-.6,3.84,5.16,1.2,5.71S261.07,168.65,263.46,168.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "264.144px 170.992px",
        }}
        id="elolyx40zxww"
        className="animable"
      />
      <path
        d="M248,167.61c.76-.31,1.41-.71,2.14-1.09a3.88,3.88,0,0,0,2-1.52,1.25,1.25,0,0,0-.4-1.46,3.08,3.08,0,0,0-3.1.09,4.53,4.53,0,0,0-2.31,2.27A1.32,1.32,0,0,0,248,167.61Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "249.238px 165.424px",
        }}
        id="elfc7lc9d6bpq"
        className="animable"
      />
      <path
        d="M265.31,164.93a21.18,21.18,0,0,1-2.38-.29,3.9,3.9,0,0,1-2.37-.76,1.25,1.25,0,0,1-.12-1.51,3.06,3.06,0,0,1,2.94-1,4.53,4.53,0,0,1,2.95,1.35A1.32,1.32,0,0,1,265.31,164.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "263.459px 163.119px",
        }}
        id="el4ayoab5f6u1"
        className="animable"
      />
      <path
        d="M252.22,188.17c.49.37,1,.89,1.65.86a4.74,4.74,0,0,0,1.87-.71.06.06,0,0,1,.09.08,2.45,2.45,0,0,1-2.15,1.28,2,2,0,0,1-1.62-1.4C252,188.18,252.15,188.12,252.22,188.17Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "253.945px 188.916px",
        }}
        id="elco9fri0pjnj"
        className="animable"
      />
      <path
        d="M259.14,184a7.35,7.35,0,0,1-2.61,2.63,3.25,3.25,0,0,1-2,.39c-1.48-.19-1.69-1.5-1.58-2.66a7.77,7.77,0,0,1,.42-1.81A9.42,9.42,0,0,0,259.14,184Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "256.033px 184.798px",
        }}
        id="elcfpmged8ewt"
        className="animable"
      />
      <path
        d="M253.4,182.55a6.15,6.15,0,0,0,4.44,2.18,7.52,7.52,0,0,0,2.21-.19,1.89,1.89,0,0,0,.41-.1l.38-.11a.45.45,0,0,0,.31-.45v0a1.49,1.49,0,0,0,0-.18h0l0-.16c-.14-1.38-.55-3.47-.55-3.47.53.19,3.26,1,3.12.29-1.14-5.92-2.42-12.51-4.81-18.17a.17.17,0,0,0-.32.09c.88,5.74,2.75,11.29,3.73,17a10.63,10.63,0,0,0-3-.5c-.19.08.87,4,.88,4.64v.07c-2.28.6-4.13.13-6.58-1.13C253.4,182.29,253.27,182.43,253.4,182.55Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "258.537px 173.422px",
        }}
        id="eld2iifrojux"
        className="animable"
      />
      <path
        d="M230.05,176.56c5.17,0,4.13-22,4.13-22s5.28,2.48,9.62,2.79a45.54,45.54,0,0,0,10.15-.52c.72-.2-8.28-3.72-8.28-3.72s11.89.72,15.2-1.24,3-2.8,2.79-4-8.74-11.08-24.1-8.23A18,18,0,0,0,226,149.94s-4.53,7.81-4.27,11.43C222.12,166.23,224.56,176.56,230.05,176.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "242.749px 157.843px",
        }}
        id="elfskekxmqdct"
        className="animable"
      />
      <path
        d="M232.56,177.22s-6.1-8.46-9.95-6.27.83,14.5,5.41,16.13a4.62,4.62,0,0,0,6.16-2.58Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "227.683px 179.026px",
        }}
        id="eliswqsftn45h"
        className="animable"
      />
      <path
        d="M224,174.45c-.07,0-.09.09,0,.12,3.21,1.24,4.93,4.18,6.15,7.23-1-1.17-2.27-1.8-3.83-.64-.08.06,0,.19.09.17a2.85,2.85,0,0,1,3.15.94,14.35,14.35,0,0,1,1.53,2.52c.16.28.67.12.56-.21l0-.07C231.66,180.44,228.42,174.79,224,174.45Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "227.803px 179.692px",
        }}
        id="elco8btnjt6w"
        className="animable"
      />
      <path
        d="M249.74,139a36.81,36.81,0,0,0-10.47-2.59c-4-.32-16.6,1.25-19.5,3.92s-3.14,14.6-3.14,16.34,1.27,12.22,5.2,14.57,3.44-15.51,9.17-21.72S249.74,139,249.74,139Z"
        style={{
          fill: "#213E60",
          transformOrigin: "233.185px 153.91px",
        }}
        id="elsio0xbk29f"
        className="animable"
      />
      <g id="elkz1m2pbxkd">
        <path
          d="M249.74,139s-13,4.32-18.73,10.53-5.26,24.07-9.19,21.72c-1.73-1-2.62-2.66-3.44-5.42.55-5.26,2.28-13.45,6.36-19.26,3.83-5.45,10.71-8.44,18.17-9.64A42.79,42.79,0,0,1,249.74,139Z"
          style={{
            opacity: 0.1,
            transformOrigin: "234.06px 154.196px",
          }}
          className="animable"
          id="elan78yuvz77h"
        />
      </g>
      <path
        d="M223.37,181.77c.11-4.78,4.35-17.74,9.08-25.28S251.9,144,254,144c5.08.05,6.87,1.5,7.65,1s-4.61-4-6.08-4.84-5.39-2.62-7.59-2.46-15.71,2.15-20.37,8.17-10.88,22.58-9.4,26.67c.35,1,1.71,1.56,2.2,2.95.64,1.83,1.13,4,1.75,5.23C222.65,181.76,223.36,182.18,223.37,181.77Z"
        style={{
          fill: "#213E60",
          transformOrigin: "239.857px 159.808px",
        }}
        id="elda9cvy0z6ta"
        className="animable"
      />
      <path
        d="M233.46,153.15a23.34,23.34,0,0,1-3.4-2.26,17.11,17.11,0,0,1-3-2.87c-.06-.08-.19,0-.13.08a13.3,13.3,0,0,0,2.72,3.26,11.27,11.27,0,0,0,3.68,2C233.51,153.45,233.59,153.23,233.46,153.15Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "230.219px 150.684px",
        }}
        id="elxgf0ylxhgi"
        className="animable"
      />
      <path
        d="M223.1,177c-.15-.34-.39-.63-.57-1a5.89,5.89,0,0,1-.5-1.15,10.69,10.69,0,0,0-.65-2.29,8.38,8.38,0,0,0-1.19-1.53,3.2,3.2,0,0,1-1-1.89c0-.1-.16-.09-.16,0,.07,1.44,1.09,2.42,1.77,3.6a15,15,0,0,1,.77,2.44,3.71,3.71,0,0,0,1.35,1.93C223,177.24,223.15,177.13,223.1,177Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "221.07px 173.118px",
        }}
        id="el1dmshufrdy2"
        className="animable"
      />
      <path
        d="M224.5,171.8c-.48-.53-1-1-1.42-1.56a14.07,14.07,0,0,1-1.1-1.73c-.33-.59-.61-1.2-.93-1.8s-.83-1.37-1.17-2.09c0-.09-.18,0-.14.09.35.74.58,1.55.9,2.31a18,18,0,0,0,1,1.9,10.37,10.37,0,0,0,1.21,1.66,5.08,5.08,0,0,0,1.59,1.29C224.49,171.89,224.53,171.83,224.5,171.8Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "222.122px 168.228px",
        }}
        id="elqsjwl2f2yz"
        className="animable"
      />
      <path
        d="M226,167.06a13.67,13.67,0,0,1-2.73-2.8c-.74-1-1.43-2.13-2.09-3.21-.05-.08-.18,0-.15.06a16.2,16.2,0,0,0,1.81,3.54,8.41,8.41,0,0,0,1.29,1.44,8.77,8.77,0,0,0,1.77,1.11C226,167.24,226.08,167.12,226,167.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "223.529px 164.112px",
        }}
        id="elyphenn52sw"
        className="animable"
      />
      <path
        d="M227.68,162.52a4.76,4.76,0,0,1-1.32-1.21c-.44-.52-.86-1-1.27-1.58s-.8-1-1.19-1.54a4.74,4.74,0,0,1-.94-1.7.08.08,0,0,0-.15,0,4.85,4.85,0,0,0,.63,1.84,12.41,12.41,0,0,0,1.17,1.81,17.61,17.61,0,0,0,1.41,1.59,3.08,3.08,0,0,0,1.58,1C227.72,162.74,227.8,162.58,227.68,162.52Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "225.275px 159.584px",
        }}
        id="el619ag6cccgq"
        className="animable"
      />
      <path
        d="M228.77,156.81c-.46-.41-.92-.83-1.34-1.27s-.84-.92-1.23-1.39-.85-1-1.23-1.5a.08.08,0,0,0-.14.09,12.14,12.14,0,0,0,1,1.68A12.46,12.46,0,0,0,227,155.9a15.5,15.5,0,0,0,1.38,1.31,4.78,4.78,0,0,0,1.59,1,.12.12,0,0,0,.13-.17A9.29,9.29,0,0,0,228.77,156.81Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "227.464px 155.412px",
        }}
        id="eloln59bv6b6m"
        className="animable"
      />
      <path
        d="M237,150.28a19.66,19.66,0,0,0-1.53-1.63,18.93,18.93,0,0,0-1.76-1.46,19.75,19.75,0,0,0-3.81-2.31c-.08,0-.17.06-.09.12,2.34,1.82,4.76,3.55,7.08,5.39C237,150.45,237.05,150.35,237,150.28Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "233.399px 147.644px",
        }}
        id="eluq8bhecc78l"
        className="animable"
      />
      <path
        d="M239.67,146.07a9.8,9.8,0,0,0-1.69-1.46,20.86,20.86,0,0,0-4.18-2.07.08.08,0,0,0-.08.14c1.27.76,2.56,1.5,3.79,2.33a20.59,20.59,0,0,1,1.76,1.31c.56.48,1,1.07,1.54,1.57,0,0,.12,0,.1-.06A5.57,5.57,0,0,0,239.67,146.07Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "237.296px 145.21px",
        }}
        id="el8of9qj1z6i7"
        className="animable"
      />
      <path
        d="M243.54,144a9.79,9.79,0,0,0-1.56-1.46,12.1,12.1,0,0,0-3.57-1.88c-.09,0-.14.1-.06.15a23.82,23.82,0,0,1,3.39,2.22c.53.42,1,.87,1.56,1.3s1,1,1.51,1.39a.05.05,0,0,0,.07-.08A10.55,10.55,0,0,0,243.54,144Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "241.604px 143.197px",
        }}
        id="ela0nhp8m9nth"
        className="animable"
      />
      <path
        d="M246.29,141.51c-.52-.38-1-.74-1.59-1.09a5.89,5.89,0,0,0-1.7-.85c-.09,0-.13.1-.06.14,1,.73,2,1.48,3,2.23a16.48,16.48,0,0,1,2.35,2.52s.11,0,.09-.05A6,6,0,0,0,246.29,141.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "245.643px 142.015px",
        }}
        id="elrxdjj7wj0mm"
        className="animable"
      />
      <path
        d="M249.83,140.57a9.74,9.74,0,0,0-3.27-1.82c-.09,0-.14.11-.06.14a11.73,11.73,0,0,1,3,2,16.76,16.76,0,0,1,2.41,2.71c0,.05.13,0,.1,0A8.17,8.17,0,0,0,249.83,140.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "249.237px 141.186px",
        }}
        id="elrnx7tlwmqrd"
        className="animable"
      />
      <path
        d="M254.6,142.48a5.13,5.13,0,0,0-.44-.7,7.82,7.82,0,0,0-1.12-1.25,17.08,17.08,0,0,0-2.8-1.95c-.08-.05-.16.09-.07.14a13.93,13.93,0,0,1,2.63,2,12.55,12.55,0,0,1,1.08,1.22c.16.21.31.43.45.65a4.16,4.16,0,0,0,.43.66.08.08,0,0,0,.13-.06A2,2,0,0,0,254.6,142.48Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "252.51px 140.918px",
        }}
        id="elpjanpdafn6"
        className="animable"
      />
      <path
        d="M257.48,142.6a11.14,11.14,0,0,0-.92-1,10,10,0,0,0-1-.91c-.37-.28-.76-.56-1.12-.86-.08-.07-.18.06-.09.13a8.58,8.58,0,0,1,1.05.95l.94,1,.94,1a12.52,12.52,0,0,0,.94,1c.05.05.13,0,.1-.08A6.65,6.65,0,0,0,257.48,142.6Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "256.321px 141.87px",
        }}
        id="el6e7ql0pd8cw"
        className="animable"
      />
      <path
        d="M218.76,214.21c-2.23-.23,7.79-6.82,10.2-4.89s14.52,31.86,10.58,64.34-62.27,70.39-64.64,65.53c-1-2-.31-6.9,1.26-8.72,2.22-2.57,43.15-34.5,47.76-54.64C228,257.92,224.24,214.77,218.76,214.21Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "207.377px 274.29px",
        }}
        id="elrwgdii7tseq"
        className="animable"
      />
      <path
        d="M198.44,231.23c-36.91,38.89-70.25,105.61-50.13,109.08,17.39,3,72-12.85,85.45-18.57,5.88-2.49-9.48-52-15.59-48.92-5.29,2.63-12.23,5.52-13.06,5.46-1.77-.12,5.56-23.91,12-44.18C226.54,204.15,212.3,216.63,198.44,231.23Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "188.661px 278.227px",
        }}
        id="el0gz7zz2dcr7h"
        className="animable"
      />
      <path
        d="M273.86,254.18c3.61,3.87.92,8.64.92,8.64a11.29,11.29,0,0,1,6.29,4.39c2.5,3.92-2.56,9.55-2.56,9.55a14,14,0,0,1,5.9,5.7c2,4-2.28,10.4-2.28,10.4a12.14,12.14,0,0,1,2,8.27c-1.21,7.74-12.22,12.43-19.18,15.49s-29.59,5.19-33.86,6l-20-44.55s27.34-22.59,36-25C254.5,251.05,269.81,249.84,273.86,254.18Z"
        style={{
          fill: "rgb(247, 169, 160)",
          transformOrigin: "248.016px 286.93px",
        }}
        id="elx10k1zfy75"
        className="animable"
      />
      <path
        d="M274.15,262.24c-8.31.3-16.09,3.05-24,5.35a.14.14,0,0,0,.08.27c7.85-2.38,16.06-3.17,24-5.23A.2.2,0,0,0,274.15,262.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "262.21px 265.052px",
        }}
        id="el0mtl57cb98ci"
        className="animable"
      />
      <path
        d="M278.11,276.24a21.52,21.52,0,0,0-5.48,1.49c-1.9.65-3.78,1.34-5.66,2.06q-5.64,2.16-11.17,4.6c-.16.07-.09.34.09.27,3.75-1.42,7.52-2.8,11.32-4.07q2.85-.94,5.73-1.86a25.81,25.81,0,0,0,5.33-2A.29.29,0,0,0,278.11,276.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "267.032px 280.456px",
        }}
        id="elqjvcortbrep"
        className="animable"
      />
      <path
        d="M282,292.91c-1.63,0-3.36,1-4.86,1.6-1.69.69-3.4,1.38-5.1,2.05-3.42,1.34-6.83,2.69-10.29,3.91-.17.06-.09.34.09.27,3.52-1.22,7.05-2.4,10.56-3.66l5.16-1.88c1.45-.54,3.34-1.05,4.52-2.12A.11.11,0,0,0,282,292.91Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "271.877px 296.831px",
        }}
        id="elch94nukbict"
        className="animable"
      />
      <path
        d="M217.25,270.52,234,325.75s-76.55,24-89.31,14.76S159,267.59,208.34,221c17.3-16.35,14.42,2.59,8.58,21.49-6.76,21.89-9.25,33.74-9.25,33.74Z"
        style={{
          fill: "#213E60",
          transformOrigin: "187.774px 278.703px",
        }}
        id="eldn9sersrqy8"
        className="animable"
      />
      <path
        d="M217.17,270.51c-1.75.76-22.94,13.12-24.42,14.09a8.2,8.2,0,0,0-2.21.58c-.85.29-1.7.57-2.54.88-1.62.61-3.24,1.21-4.84,1.85a69.93,69.93,0,0,1-9.76,3.56c-.18,0-.09.31.09.27A90.17,90.17,0,0,0,183.67,289c1.68-.53,3.35-1.1,5-1.68l-1.76,1.16c-6.88,4.56-13.65,9.3-20.49,13.92-3.89,2.63-7.76,5.3-11.69,7.87a.14.14,0,0,0,.15.24c13.81-9,61-37.84,62.63-39.38C217.76,270.86,217.49,270.38,217.17,270.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "186.136px 290.509px",
        }}
        id="el8xjjq5z9cj6"
        className="animable"
      />
      <path
        d="M218.6,254.82c-1.25,1.59-2.73,3-4,4.53-.07.09-.14.17-.2.26,1.78-4.8,3.43-9.64,5.07-14.48a.08.08,0,0,0-.14-.06c-2.62,5.93-5.27,11.85-7.6,17.9-1.18,3-5.33,13.85-5.09,14.25.14.23.37.33.55.1,0-.06,3.52-8.23,3.75-8.8q1.1-2.75,2.16-5.5l.09-.17c.26-.36.56-.68.83-1,.56-.72,1.09-1.45,1.64-2.18,1.12-1.49,2-3.14,3.13-4.62C218.91,254.88,218.71,254.68,218.6,254.82Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "213.05px 261.246px",
        }}
        id="elr4havlj5ae"
        className="animable"
      />
      <path
        d="M234.43,325.91a6.25,6.25,0,0,0-.26-.87c-.11-.33-.23-.66-.35-1a6.71,6.71,0,0,1-.31-1c-.07-.34-.15-.69-.22-1,0-.18-.32-.1-.27.08.08.33.17.65.26,1a7.14,7.14,0,0,1,.17,1c0,.33.08.66.14,1,0,.15,0,.31.07.46s.05.3.09.44c-3.62.79-7.2,2-10.79,2.91s-7.46,2-11.2,2.93c-7.55,1.92-15.1,3.87-22.68,5.67-4.33,1-8.64,2.12-13,3-.18,0-.1.31.08.27,7.66-1.53,15.36-2.81,23-4.56s15.16-3.66,22.63-5.89c4.23-1.27,8.65-2.36,12.74-4A.19.19,0,0,0,234.43,325.91Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "205.341px 331.371px",
        }}
        id="eloao0shl7bod"
        className="animable"
      />
      <path
        d="M223.17,321.09c-.39-1.54-.81-3.06-1.24-4.59-.85-3.09-1.72-6.17-2.6-9.26-1.75-6.13-3.66-12.2-5.65-18.25-1.13-3.44-2.14-6.94-3.41-10.32a.14.14,0,0,0-.27.08c.7,3.13,1.63,6.21,2.46,9.3s1.63,6.2,2.52,9.29c1.75,6.12,3.62,12.21,5.55,18.28.54,1.7,1,3.44,1.64,5.12.31.86.56,1.74.89,2.6s.72,1.69,1,2.56a.08.08,0,0,0,.15,0C223.85,324.27,223.57,322.67,223.17,321.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "217.102px 302.261px",
        }}
        id="el775fokp9c5g"
        className="animable"
      />
    </g>
    <g
      id="freepik--speech-bubbles--inject-69"
      className="animable"
      style={{
        transformOrigin: "372.755px 90.34px",
      }}
    >
      <rect
        x={332.24}
        y={45.36}
        width={67.68}
        height={38.21}
        style={{
          fill: "#213E60",
          transformOrigin: "366.08px 64.465px",
        }}
        id="el6abukl149bn"
        className="animable"
      />
      <polygon
        points="343.69 83.58 332.24 95.32 332.24 83.58 343.69 83.58"
        style={{
          fill: "#213E60",
          transformOrigin: "337.965px 89.45px",
        }}
        id="el0slz8on3a1o"
        className="animable"
      />
      <rect
        x={342.02}
        y={53.04}
        width={40.18}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "362.11px 53.63px",
        }}
        id="elndihdj5qit9"
        className="animable"
      />
      <rect
        x={342.02}
        y={56.65}
        width={27.54}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "355.79px 57.24px",
        }}
        id="el5i0wd1gze2i"
        className="animable"
      />
      <rect
        x={342.02}
        y={60.26}
        width={48.11}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "366.075px 60.85px",
        }}
        id="elik3tsipodsp"
        className="animable"
      />
      <rect
        x={342.02}
        y={63.88}
        width={16.55}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "350.295px 64.47px",
        }}
        id="eloro5sp8gsmg"
        className="animable"
      />
      <rect
        x={342.02}
        y={67.49}
        width={37.75}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "360.895px 68.08px",
        }}
        id="elnz0qmdnsd1"
        className="animable"
      />
      <rect
        x={342.02}
        y={71.11}
        width={40.18}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "362.11px 71.7px",
        }}
        id="elgcb011w9iuf"
        className="animable"
      />
      <rect
        x={342.02}
        y={74.72}
        width={30.1}
        height={1.18}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "357.07px 75.31px",
        }}
        id="el5dwhmjzarhp"
        className="animable"
      />
      <g id="eld7ml1szurqe">
        <rect
          x={345.59}
          y={95.62}
          width={67.68}
          height={27.96}
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "379.43px 109.6px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          id="eltymb4crn4mc"
        />
      </g>
      <polygon
        points="401.82 123.58 413.27 135.32 413.27 123.58 401.82 123.58"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "407.545px 129.45px",
        }}
        id="elp1y8d4p0v2c"
        className="animable"
      />
      <rect
        x={356.02}
        y={101.55}
        width={36.44}
        height={1.22}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.24px 102.16px",
        }}
        id="elkqxxq2wh58p"
        className="animable"
      />
      <rect
        x={356.02}
        y={105.27}
        width={46.38}
        height={1.22}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "379.21px 105.88px",
        }}
        id="elimj5v5w01oc"
        className="animable"
      />
      <rect
        x={356.02}
        y={108.99}
        width={33.71}
        height={1.22}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "372.875px 109.6px",
        }}
        id="el9o085lu208m"
        className="animable"
      />
      <rect
        x={356.02}
        y={112.71}
        width={42.4}
        height={1.22}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "377.22px 113.32px",
        }}
        id="el9yau8rql82j"
        className="animable"
      />
      <rect
        x={356.02}
        y={116.43}
        width={27.8}
        height={1.22}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "369.92px 117.04px",
        }}
        id="el6bkc2oen8rw"
        className="animable"
      />
    </g>
    <g
      id="freepik--Icons--inject-69"
      className="animable"
      style={{
        transformOrigin: "238.57px 222.733px",
      }}
    >
      <path
        d="M265.23,256.51C259.54,268,246,274.8,246,274.8s-13.54-6.81-19.22-18.29c-4.74-9.58-1.74-19.93,5.75-22.19,10.72-3.24,13.47,15.44,13.47,15.44s2.76-18.68,13.49-15.44C267,236.58,270,246.93,265.23,256.51Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "246.015px 254.371px",
        }}
        id="eltjqf8fbdmzi"
        className="animable"
      />
      <rect
        x={80.16}
        y={156.66}
        width={51.83}
        height={51.83}
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "106.075px 182.575px",
        }}
        id="elfmve2vg9hlf"
        className="animable"
      />
      <path
        d="M101.26,188.07h-7v-8h6.82c0-.61.06-1.08.07-1.56,0-2.09,0-4.2.16-6.28.43-4.58,3.24-7.81,7.77-8.44,2.83-.39,5.75-.07,8.7-.07V171c-1,0-2.1,0-3.14,0a14.44,14.44,0,0,0-2.8.18,2.63,2.63,0,0,0-2.22,2.53c-.08,2,0,4.08,0,6.29h7.93c-.34,2.61-.62,5-1,7.44,0,.24-.64.53-1,.54-1.92.06-3.83,0-5.9,0v20.47h-8.44Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "106.02px 186.023px",
        }}
        id="elwifdiltxqpn"
        className="animable"
      />
      <rect
        x={345.15}
        y={278.82}
        width={51.83}
        height={51.83}
        style={{
          fill: "#213E60",
          transformOrigin: "371.065px 304.735px",
        }}
        id="elhqrihpwikq4"
        className="animable"
      />
      <path
        d="M390.13,294.21c0-5.19-3.27-8.55-8.41-8.6q-10.68-.11-21.35,0c-5,.06-8.29,3.39-8.37,8.41-.05,3.55,0,7.11,0,10.66s0,7,0,10.43c0,5.31,3.28,8.7,8.53,8.75q10.56.12,21.12,0c5.15-.06,8.44-3.44,8.47-8.57Q390.18,304.75,390.13,294.21Zm-3.41,21.14c0,3.28-1.8,5.1-5.08,5.12q-10.56.06-21.12,0c-3.3,0-5.08-1.83-5.1-5.1q0-10.65,0-21.3c0-3.25,1.83-5.12,5.08-5.15q10.56-.06,21.12,0c3.26,0,5.07,1.89,5.1,5.13,0,3.55,0,7.1,0,10.65S386.76,311.8,386.72,315.35Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "371.065px 304.737px",
        }}
        id="el06xig79b2v33"
        className="animable"
      />
      <path
        d="M371.09,294.73a10,10,0,1,0,9.9,10.11A10,10,0,0,0,371.09,294.73Zm-.13,16.6a6.72,6.72,0,0,1-6.53-6.56,6.64,6.64,0,0,1,13.28,0A6.73,6.73,0,0,1,371,311.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "370.991px 304.73px",
        }}
        id="ellk22d5033rd"
        className="animable"
      />
      <path
        d="M384,294.5a2.07,2.07,0,0,1-2.37,2.06,2.1,2.1,0,0,1-2.17-2.49,2.21,2.21,0,0,1,2.4-2.12A2.24,2.24,0,0,1,384,294.5Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "381.722px 294.262px",
        }}
        id="elnx0rf1wqmlr"
        className="animable"
      />
      <path
        d="M140.27,147.76c1.14,7.39-3,15.19-3,15.19s-8.75,1.3-15.32-2.27c-5.48-3-7.52-8.92-4.71-12.52,4-5.15,11.62,2.84,11.62,2.84s-5-9.84,1.25-11.9C134.4,137.66,139.31,141.6,140.27,147.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "128.225px 150.992px",
        }}
        id="el1mlrb3agn2i"
        className="animable"
      />
      <path
        d="M150.81,126.78c-3.31,4.4-9.56,6.21-9.56,6.21s-5.18-3.94-6.68-9.24c-1.25-4.42.84-8.55,4.17-8.91,4.79-.53,4.48,7.58,4.48,7.58s2.63-7.68,6.91-5.46C153.11,118.5,153.57,123.11,150.81,126.78Z"
        style={{
          fill: "#213E60",
          transformOrigin: "143.424px 123.903px",
        }}
        id="el60hzz0yu0rk"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default ContentSVG;
